export * from "./tokens";
export * from "./social.tsx";

function Icon(props: any) {
    return (
        <span role="img" onClick={props.onClick} className={props.className}>
            {props.component()}
        </span>
    );
}

export const IconCandler = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_7259_50401)">
                    <path
                        d="M13.3374 4.16911H11.3373C11.0612 4.16911 10.8373 4.39297 10.8373 4.66911V11.1691C10.8373 11.4452 11.0612 11.6691 11.3373 11.6691H13.3374V13.3357C13.3374 13.796 13.7105 14.1691 14.1707 14.1691C14.6309 14.1691 15.004 13.796 15.004 13.3357V11.6691H16.504C17.0563 11.6691 17.504 11.2214 17.504 10.6691V4.66911C17.504 4.39297 17.2802 4.16911 17.004 4.16911H15.004V2.50244C15.004 2.0422 14.6309 1.66911 14.1707 1.66911C13.7105 1.66911 13.3374 2.0422 13.3374 2.50244V4.16911ZM15.8374 5.83577V10.0024H12.504V5.83577H15.8374ZM5.00401 8.33575H3.00401C2.72787 8.33575 2.50401 8.55961 2.50401 8.83575V15.3357C2.50401 15.6119 2.72787 15.8357 3.00401 15.8357H5.00401V17.5024C5.00401 17.9627 5.37711 18.3357 5.83734 18.3357C6.29758 18.3357 6.67068 17.9627 6.67068 17.5024V15.8357H8.67068C8.94682 15.8357 9.17068 15.6119 9.17068 15.3357V8.83575C9.17068 8.55961 8.94682 8.33575 8.67068 8.33575H6.67068V6.66911C6.67068 6.20887 6.29758 5.83577 5.83734 5.83577C5.37711 5.83577 5.00401 6.20887 5.00401 6.66911V8.33575ZM7.50401 10.0024V14.1691H4.17068V10.0024H7.50401Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_7259_50401">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);

export const IconCopy = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.9165 9.91667V11.6667C9.9165 12.311 9.39417 12.8333 8.74984 12.8333H2.33317C1.68884 12.8333 1.1665 12.311 1.1665 11.6667V5.25C1.1665 4.60567 1.68884 4.08334 2.33317 4.08334H4.08317V2.33334C4.08317 1.68901 4.6055 1.16667 5.24984 1.16667H11.6665C12.3108 1.16667 12.8332 1.68901 12.8332 2.33334V8.75C12.8332 9.39434 12.3108 9.91667 11.6665 9.91667H9.9165ZM11.6665 2.33334H5.24984V4.08334H8.74984C9.39417 4.08334 9.9165 4.60567 9.9165 5.25V8.75H11.6665V2.33334ZM8.45817 5.25C8.61925 5.25 8.74984 5.38059 8.74984 5.54167V11.375C8.74984 11.5361 8.61925 11.6667 8.45817 11.6667H2.62484C2.46375 11.6667 2.33317 11.5361 2.33317 11.375L2.33317 5.54167C2.33317 5.38059 2.46375 5.25 2.62484 5.25H8.45817Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconBrowser = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM15.5 8.5L13.5 13.5L8.5 15.5L10.5 10.5L15.5 8.5Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconInfo = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.5 10.5218C11.9477 10.5218 11.5 10.9695 11.5 11.5218V16C11.5 16.5523 11.9477 17 12.5 17C13.0523 17 13.5 16.5523 13.5 16V11.5218C13.5 10.9695 13.0523 10.5218 12.5 10.5218Z"
                    fill="currentColor"
                />
                <path
                    d="M13.7008 8.23613C13.7008 8.89887 13.1635 9.43613 12.5008 9.43613C11.838 9.43613 11.3008 8.89887 11.3008 8.23613C11.3008 7.57339 11.838 7.03613 12.5008 7.03613C13.1635 7.03613 13.7008 7.57339 13.7008 8.23613Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12ZM20.5 12C20.5 16.4183 16.9183 20 12.5 20C8.08172 20 4.5 16.4183 4.5 12C4.5 7.58172 8.08172 4 12.5 4C16.9183 4 20.5 7.58172 20.5 12Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconArrowUp = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.0029 7.62298V18.793C13.0029 19.343 12.5529 19.793 12.0029 19.793C11.4529 19.793 11.0029 19.343 11.0029 18.793V7.62298L6.35289 12.283C5.96289 12.673 5.33289 12.673 4.94289 12.283C4.55289 11.893 4.55289 11.263 4.94289 10.873L11.3029 4.50298C11.6929 4.11298 12.3229 4.11298 12.7129 4.50298L19.0729 10.863C19.4629 11.253 19.4629 11.883 19.0729 12.273C18.6829 12.663 18.0529 12.663 17.6629 12.273L13.0029 7.61298V7.62298Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconArrowUpChain = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.28953 9.78947C5.28953 10.1819 5.60764 10.5 6.00005 10.5C6.39246 10.5 6.71058 10.1819 6.71058 9.78947V3.92589L8.81342 6.02873C9.0909 6.30621 9.54078 6.30621 9.81826 6.02873C10.0957 5.75126 10.0957 5.30138 9.81826 5.0239L6.50247 1.70811C6.22499 1.43063 5.77511 1.43063 5.49763 1.70811L2.18184 5.0239C1.90437 5.30138 1.90437 5.75126 2.18184 6.02873C2.45932 6.30621 2.9092 6.30621 3.18668 6.02873L5.28953 3.92589V9.78947Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconArrowDown = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.9892 16.377L17.6492 11.717C18.0392 11.327 18.6692 11.327 19.0592 11.717C19.4492 12.107 19.4492 12.737 19.0592 13.127L12.6992 19.487C12.3092 19.877 11.6792 19.877 11.2892 19.487L4.92922 13.127C4.53922 12.737 4.53922 12.107 4.92922 11.717C5.31922 11.327 5.94922 11.327 6.33922 11.717L10.9992 16.377V5.20703C10.9992 4.65703 11.4492 4.20703 11.9992 4.20703C12.5492 4.20703 12.9992 4.65703 12.9992 5.20703V16.377H12.9892Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconArrowDownChain = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.71047 2.21053C6.71047 1.81811 6.39236 1.5 5.99995 1.5C5.60754 1.5 5.28942 1.81811 5.28942 2.21053V8.07411L3.18658 5.97127C2.9091 5.69379 2.45922 5.69379 2.18174 5.97127C1.90426 6.24874 1.90426 6.69862 2.18174 6.9761L5.49753 10.2919C5.77501 10.5694 6.22489 10.5694 6.50237 10.2919L9.81816 6.9761C10.0956 6.69862 10.0956 6.24874 9.81816 5.97127C9.54068 5.69379 9.0908 5.69379 8.81332 5.97127L6.71047 8.07411V2.21053Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconScan = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6 5H18C18.5523 5 19 5.44772 19 6V8C19 8.55228 19.4477 9 20 9C20.5523 9 21 8.55228 21 8V6C21 4.34315 19.6569 3 18 3H6C4.34315 3 3 4.34315 3 6V8C3 8.55228 3.44772 9 4 9C4.55228 9 5 8.55228 5 8V6C5 5.44772 5.44772 5 6 5Z"
                    fill="currentColor"
                />
                <path
                    d="M5 16C5 15.4477 4.55228 15 4 15C3.44772 15 3 15.4477 3 16V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V16C21 15.4477 20.5523 15 20 15C19.4477 15 19 15.4477 19 16V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V16Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSuccess = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.637 2.49408C10.9543 2.81951 10.9543 3.34715 10.637 3.67259L4.94952 9.50592C4.63222 9.83136 4.11778 9.83136 3.80048 9.50592L1.36298 7.00592C1.04567 6.68049 1.04567 6.15285 1.36298 5.82741C1.68028 5.50197 2.19472 5.50197 2.51202 5.82741L4.375 7.73815L9.48798 2.49408C9.80528 2.16864 10.3197 2.16864 10.637 2.49408Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconClose = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.46967 2.46967C2.76256 2.17678 3.23744 2.17678 3.53033 2.46967L6 4.93934L8.46967 2.46967C8.76256 2.17678 9.23744 2.17678 9.53033 2.46967C9.82322 2.76256 9.82322 3.23744 9.53033 3.53033L7.06066 6L9.53033 8.46967C9.82322 8.76256 9.82322 9.23744 9.53033 9.53033C9.23744 9.82322 8.76256 9.82322 8.46967 9.53033L6 7.06066L3.53033 9.53033C3.23744 9.82322 2.76256 9.82322 2.46967 9.53033C2.17678 9.23744 2.17678 8.76256 2.46967 8.46967L4.93934 6L2.46967 3.53033C2.17678 3.23744 2.17678 2.76256 2.46967 2.46967Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconLoading = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mt-[0.1em]"
            >
                <use xlinkHref="#spinner_24" fill="none">
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="rotate"
                        from="0 12 12"
                        to="360 12 12"
                        dur="0.7s"
                        repeatCount="indefinite"
                    ></animateTransform>
                </use>
                <symbol
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    id="spinner_24"
                >
                    <path
                        d="M12 3c1.5644 0 3.1018.40778 4.4605 1.18312 1.3588.77535 2.492 1.89147 3.2878 3.23831.7959 1.34683 1.2269 2.87787 1.2507 4.44207.0237 1.5642-.3607 3.1076-1.1154 4.478-.7546 1.3703-1.8534 2.5203-3.188 3.3365-1.3347.8162-2.859 1.2704-4.4227 1.3179-1.5636.0474-3.11269-.3136-4.49433-1.0473-1.38163-.7338-2.54815-1.8151-3.38448-3.1371"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                    ></path>
                </symbol>
            </svg>
        )}
        {...props}
    />
);
export const IconWalletFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.33325 3.60355V3.63008V12.3437C1.33325 13.2642 2.07944 14.0104 2.99992 14.0104H12.9999C13.9204 14.0104 14.6666 13.2642 14.6666 12.3437V5.9388C14.6666 5.01833 13.9204 4.27214 12.9999 4.27214H12.203C12.1897 4.27108 12.1763 4.27054 12.1627 4.27054H2.97371C2.62 4.27054 2.33325 3.98379 2.33325 3.63008C2.33325 3.27636 2.62 2.98962 2.97371 2.98962H12.8293C13.1055 2.98962 13.3293 2.76576 13.3293 2.48962C13.3293 2.21348 13.1055 1.98962 12.8293 1.98962H2.97371C2.07651 1.98962 1.34732 2.70969 1.33325 3.60355ZM12.648 9.33337C13.0162 9.33337 13.3147 9.0349 13.3147 8.66671C13.3147 8.29852 13.0162 8.00004 12.648 8.00004L9.98136 8.00004C9.61317 8.00004 9.3147 8.29852 9.3147 8.66671C9.3147 9.0349 9.61317 9.33337 9.98136 9.33337L12.648 9.33337Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconWalletLogo = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.59 29.1197V33.7278C17.5821 33.8524 17.5781 33.978 17.5781 34.1046V55.6066C17.5781 58.8457 20.204 61.4715 23.4431 61.4715H56.5908C59.8299 61.4715 62.4557 58.8457 62.4557 55.6066V50.719H57.1584C53.659 50.719 50.8221 47.8821 50.8221 44.3827C50.8221 40.8834 53.659 38.0466 57.1584 38.0466H62.4557V34.1048C62.4557 30.8657 59.8299 28.2398 56.5908 28.2398H56.4954L55.2076 22.8051C54.6405 20.412 52.3691 18.8244 49.9268 19.1141L23.8751 22.2049C20.5264 22.6022 17.9177 25.2973 17.6297 28.6571L17.59 29.1197ZM50.2321 21.6879L24.1804 24.7787C22.0527 25.0311 20.395 26.7436 20.212 28.8784L20.1819 29.2293C21.1144 28.6043 22.2361 28.2398 23.443 28.2398H53.8318L52.6856 23.4028C52.4222 22.2908 51.3668 21.5533 50.2321 21.6879ZM39.4193 45.0791L48.4141 34.6678C48.6458 34.4 48.4554 33.9841 48.101 33.9841H42.7853C42.665 33.9841 42.5506 34.0364 42.472 34.1273L36.2333 41.3591L39.4193 45.0791ZM30.3167 55.7809C30.4367 55.7809 30.5508 55.7285 30.6291 55.6374L38.7285 46.2068C38.8187 46.1017 38.8477 45.9626 38.8154 45.8356L38.8207 45.8294L38.8328 45.8397C38.8349 45.8291 38.8375 45.8185 38.8405 45.808L38.8141 45.8306C38.7985 45.7724 38.77 45.7169 38.7285 45.6686L30.6291 36.237C30.5508 36.1459 30.4367 36.0934 30.3167 36.0934H25.0222C24.6699 36.0934 24.4801 36.5076 24.7098 36.7752L32.3471 45.6686C32.3893 45.7177 32.4181 45.7743 32.4335 45.8337C32.4175 45.8998 32.418 45.969 32.4352 46.0349C32.4202 46.0967 32.3909 46.1558 32.3471 46.2068L24.7099 55.0992C24.4801 55.3667 24.6699 55.7809 25.0223 55.7809H30.3167ZM40.9249 55.7809C40.804 55.7809 40.6891 55.7281 40.6105 55.6364L36.1766 50.4638L39.3866 46.7291L46.5597 55.0987C46.7895 55.3669 46.5987 55.7809 46.2453 55.7809H40.9249Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M63.2969 40.6247H57.3301C55.1803 40.6247 53.4375 42.3674 53.4375 44.5172C53.4375 46.667 55.1803 48.4098 57.3301 48.4098H63.2969C64.0734 48.4098 64.703 47.7802 64.703 47.0037V42.0308C64.703 41.2542 64.0734 40.6247 63.2969 40.6247ZM57.4316 46.4692C58.5494 46.4692 59.4555 45.5631 59.4555 44.4454C59.4555 43.3277 58.5494 42.4216 57.4316 42.4216C56.3139 42.4216 55.4078 43.3277 55.4078 44.4454C55.4078 45.5631 56.3139 46.4692 57.4316 46.4692Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconSwapLoading = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconTabActivityFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20.75 22H4.75C4.2 22 3.75 21.55 3.75 21V3C3.75 2.45 4.2 2 4.75 2H20.75C21.3 2 21.75 2.45 21.75 3V21C21.75 21.55 21.3 22 20.75 22ZM8.75 10C8.75 10.55 9.2 11 9.75 11H15.75C16.3 11 16.75 10.55 16.75 10C16.75 9.45 16.3 9 15.75 9H9.75C9.2 9 8.75 9.45 8.75 10ZM8.75 14C8.75 14.55 9.2 15 9.75 15H12.75C13.3 15 13.75 14.55 13.75 14C13.75 13.45 13.3 13 12.75 13H9.75C9.2 13 8.75 13.45 8.75 14Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconQuestion = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="0.9523em"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 16.6667C14.1819 16.6667 17.1666 13.6819 17.1666 9.99999C17.1666 6.31809 14.1819 3.33332 10.5 3.33332C6.81806 3.33332 3.83329 6.31809 3.83329 9.99999C3.83329 13.6819 6.81806 16.6667 10.5 16.6667ZM10.5 18.3333C15.1023 18.3333 18.8333 14.6024 18.8333 9.99999C18.8333 5.39762 15.1023 1.66666 10.5 1.66666C5.89759 1.66666 2.16663 5.39762 2.16663 9.99999C2.16663 14.6024 5.89759 18.3333 10.5 18.3333Z"
                    fill="currentColor"
                />
                <path
                    d="M9.589 6.89279C9.92834 6.69336 10.3273 6.62046 10.7152 6.687C11.1032 6.75354 11.455 6.95523 11.7085 7.25634C11.962 7.55746 12.1007 7.93856 12.1001 8.33216L12.1001 8.3334C12.1001 8.72435 11.7959 9.13192 11.2212 9.51503C10.9592 9.68968 10.6913 9.82422 10.4856 9.91564C10.384 9.96083 10.3004 9.99419 10.2442 10.0156C10.2162 10.0263 10.1952 10.0339 10.1824 10.0385L10.1691 10.0431C9.73301 10.189 9.49746 10.6606 9.6429 11.0969C9.78844 11.5335 10.2604 11.7695 10.697 11.624L10.7407 11.6088L10.698 11.6236L10.6993 11.6232L10.7026 11.6221L10.7118 11.619L10.7407 11.6088C10.7645 11.6004 10.7972 11.5884 10.8376 11.5731C10.9181 11.5424 11.0298 11.4976 11.1625 11.4387C11.4256 11.3217 11.7827 11.1438 12.1457 10.9018C12.8209 10.4516 13.7664 9.60946 13.7668 8.33416C13.7679 7.54714 13.4904 6.78511 12.9836 6.18301C12.4766 5.58078 11.7729 5.17741 10.997 5.04432C10.2211 4.91124 9.4232 5.05704 8.74453 5.4559C8.06586 5.85476 7.55025 6.48094 7.28903 7.22353C7.1363 7.65769 7.36444 8.13345 7.7986 8.28618C8.23276 8.43891 8.70852 8.21076 8.86125 7.77661C8.99186 7.40531 9.24967 7.09222 9.589 6.89279Z"
                    fill="currentColor"
                />
                <path
                    d="M10.5007 14.6487C11.053 14.6487 11.5007 14.201 11.5007 13.6487C11.5007 13.0964 11.053 12.6487 10.5007 12.6487C9.94841 12.6487 9.50069 13.0964 9.50069 13.6487C9.50069 14.201 9.94841 14.6487 10.5007 14.6487Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconLightningFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.58341 5.83331H11.0834L6.41675 13.4166V8.16665H2.91675L7.58341 0.583313V5.83331Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconLightningChain = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="8" cy="8" r="8" fill="#FFC400" />
                <path
                    d="M8.44423 7.11111H11.1109L7.55534 12.8889V8.88889H4.88867L8.44423 3.11111V7.11111Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconExternal = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5.83333 4.08333C5.83333 4.40417 5.57083 4.66667 5.25 4.66667H2.91667V11.0833H9.33333V8.75C9.33333 8.42917 9.59583 8.16667 9.91667 8.16667C10.2375 8.16667 10.5 8.42917 10.5 8.75V11.6667C10.5 11.9875 10.2375 12.25 9.91667 12.25H2.33333C2.0125 12.25 1.75 11.9875 1.75 11.6667V4.08333C1.75 3.7625 2.0125 3.5 2.33333 3.5H5.25C5.57083 3.5 5.83333 3.7625 5.83333 4.08333ZM12.25 2.33333V5.83333C12.25 6.15417 11.9875 6.41667 11.6667 6.41667C11.3458 6.41667 11.0833 6.15417 11.0833 5.83333V3.73917L6.9475 7.875C6.72 8.1025 6.3525 8.1025 6.125 7.875C5.8975 7.6475 5.8975 7.28 6.125 7.0525L10.255 2.91667H8.16667C7.84583 2.91667 7.58333 2.65417 7.58333 2.33333C7.58333 2.0125 7.84583 1.75 8.16667 1.75H11.6667C11.9875 1.75 12.25 2.0125 12.25 2.33333Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconToastSuccess = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.6666 14C25.6666 20.4433 20.4433 25.6667 14 25.6667C7.55666 25.6667 2.33331 20.4433 2.33331 14C2.33331 7.55668 7.55666 2.33333 14 2.33333C20.4433 2.33333 25.6666 7.55668 25.6666 14ZM17.7063 10.6522L12.6606 15.6979L10.2931 13.3305C9.83747 12.8749 9.09878 12.8749 8.64317 13.3305C8.18756 13.7861 8.18756 14.5248 8.64318 14.9804L11.8356 18.1728C12.2912 18.6284 13.0299 18.6284 13.4855 18.1728L19.3562 12.3021C19.8118 11.8465 19.8118 11.1078 19.3562 10.6522C18.9006 10.1966 18.1619 10.1966 17.7063 10.6522Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconToastFail = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.6666 14C25.6666 20.4433 20.4433 25.6667 14 25.6667C7.55666 25.6667 2.33331 20.4433 2.33331 14C2.33331 7.55668 7.55666 2.33334 14 2.33334C20.4433 2.33334 25.6666 7.55668 25.6666 14ZM18.008 16.2255C18.4997 16.7172 18.4997 17.5144 18.008 18.0061C17.5164 18.4977 16.7192 18.4977 16.2275 18.0061L14.001 15.7795L11.7742 18.0063C11.2826 18.498 10.4854 18.4979 9.99374 18.0063C9.50206 17.5146 9.50206 16.7174 9.99373 16.2258L12.2205 13.999L9.99575 11.7743C9.50407 11.2826 9.50407 10.4854 9.99575 9.99376C10.4874 9.50208 11.2846 9.50208 11.7763 9.99376L14.001 12.2185L16.2255 9.99398C16.7172 9.5023 17.5144 9.5023 18.006 9.99398C18.4977 10.4857 18.4977 11.2828 18.006 11.7745L15.7815 13.999L18.008 16.2255Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconToastGeneral = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 25.6667C20.4433 25.6667 25.6666 20.4433 25.6666 14C25.6666 7.55667 20.4433 2.33333 14 2.33333C7.55666 2.33333 2.33331 7.55667 2.33331 14C2.33331 20.4433 7.55666 25.6667 14 25.6667ZM14 10.6745C14.8536 10.6745 15.5456 9.98252 15.5456 9.12891C15.5456 8.27531 14.8536 7.58333 14 7.58333C13.1464 7.58333 12.4544 8.27531 12.4544 9.12891C12.4544 9.98252 13.1464 10.6745 14 10.6745ZM12.711 13.3607C12.711 12.6494 13.2876 12.0728 13.999 12.0728C14.7103 12.0728 15.287 12.6494 15.287 13.3607V19.1287C15.287 19.84 14.7103 20.4167 13.999 20.4167C13.2876 20.4167 12.711 19.84 12.711 19.1287V13.3607Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconGlobal = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.70734 10.8333H6.27228C6.42144 13.5573 7.2974 16.0878 8.70957 18.2341C4.98924 17.6559 2.08299 14.6168 1.70734 10.8333ZM1.70734 9.16667C2.08299 5.38309 4.98924 2.34399 8.70957 1.76587C7.2974 3.91215 6.42144 6.44261 6.27228 9.16667H1.70734ZM18.2917 9.16667H13.7267C13.5776 6.44261 12.7017 3.91215 11.2895 1.76587C15.0098 2.34399 17.9161 5.38309 18.2917 9.16667ZM18.2917 10.8333C17.9161 14.6168 15.0098 17.6559 11.2895 18.2341C12.7017 16.0878 13.5776 13.5573 13.7267 10.8333H18.2917ZM7.9418 10.8333H12.0572C11.9142 13.1523 11.1784 15.311 9.99949 17.1596C8.82057 15.311 8.08481 13.1523 7.9418 10.8333ZM7.9418 9.16667C8.08481 6.8476 8.82057 4.68895 9.99949 2.84036C11.1784 4.68895 11.9142 6.8476 12.0572 9.16667H7.9418Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSend = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.62174 7.7628C1.18629 7.61765 1.18285 7.38346 1.6307 7.23417L17.5359 1.93245C17.9763 1.78565 18.2289 2.03216 18.1054 2.46406L13.5611 18.3693C13.4353 18.8096 13.1814 18.8249 12.9954 18.4063L9.99994 11.6666L14.9999 4.99998L8.33329 9.99994L1.62174 7.7628Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconScan2 = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.13439 1.6665L6.66651 1.66651C7.12674 1.66651 7.49984 2.0396 7.49984 2.49984C7.49984 2.96008 7.12674 3.33317 6.66651 3.33317H5.16651C4.68604 3.33317 4.37582 3.33382 4.1397 3.35311C3.91332 3.37161 3.82938 3.40301 3.78818 3.424C3.63138 3.50389 3.50389 3.63138 3.424 3.78818C3.40301 3.82938 3.37161 3.91332 3.35311 4.1397C3.33382 4.37582 3.33317 4.68604 3.33317 5.16651V6.66651C3.33317 7.12674 2.96008 7.49984 2.49984 7.49984C2.0396 7.49984 1.66651 7.12674 1.66651 6.66651L1.6665 5.13439V5.13438C1.66649 4.69509 1.66648 4.31612 1.69198 4.00398C1.7189 3.67453 1.77833 3.34685 1.93899 3.03153C2.17867 2.56112 2.56112 2.17867 3.03153 1.93899C3.34685 1.77833 3.67453 1.7189 4.00398 1.69198C4.31612 1.66648 4.69509 1.66649 5.13438 1.6665H5.13439ZM5.13439 18.3332L6.66651 18.3332C7.12674 18.3332 7.49984 17.9601 7.49984 17.4998C7.49984 17.0396 7.12674 16.6665 6.66651 16.6665H5.16651C4.68604 16.6665 4.37582 16.6659 4.1397 16.6466C3.91332 16.6281 3.82938 16.5967 3.78818 16.5757C3.63138 16.4958 3.50389 16.3683 3.424 16.2115C3.40301 16.1703 3.37161 16.0864 3.35311 15.86C3.33382 15.6239 3.33317 15.3136 3.33317 14.8332V13.3332C3.33317 12.8729 2.96008 12.4998 2.49984 12.4998C2.0396 12.4998 1.66651 12.8729 1.66651 13.3332L1.6665 14.8653C1.66649 15.3046 1.66648 15.6835 1.69198 15.9957C1.7189 16.3251 1.77833 16.6528 1.93899 16.9681C2.17867 17.4386 2.56112 17.821 3.03153 18.0607C3.34685 18.2213 3.67453 18.2808 4.00398 18.3077C4.3161 18.3332 4.69504 18.3332 5.13429 18.3332H5.13439ZM13.3332 1.66651L14.8653 1.6665C15.3046 1.66649 15.6835 1.66648 15.9957 1.69198C16.3251 1.7189 16.6528 1.77833 16.9681 1.93899C17.4386 2.17867 17.821 2.56112 18.0607 3.03153C18.2213 3.34685 18.2808 3.67453 18.3077 4.00398C18.3332 4.3161 18.3332 4.69504 18.3332 5.13429V5.13439L18.3332 6.66651C18.3332 7.12674 17.9601 7.49984 17.4998 7.49984C17.0396 7.49984 16.6665 7.12674 16.6665 6.66651V5.16651C16.6665 4.68604 16.6659 4.37582 16.6466 4.1397C16.6281 3.91332 16.5967 3.82938 16.5757 3.78818C16.4958 3.63138 16.3683 3.50389 16.2115 3.424C16.1703 3.40301 16.0864 3.37161 15.86 3.35311C15.6239 3.33382 15.3136 3.33317 14.8332 3.33317H13.3332C12.8729 3.33317 12.4998 2.96008 12.4998 2.49984C12.4998 2.0396 12.8729 1.66651 13.3332 1.66651ZM14.8653 18.3332L13.3332 18.3332C12.8729 18.3332 12.4998 17.9601 12.4998 17.4998C12.4998 17.0396 12.8729 16.6665 13.3332 16.6665H14.8332C15.3136 16.6665 15.6239 16.6659 15.86 16.6466C16.0864 16.6281 16.1703 16.5967 16.2115 16.5757C16.3683 16.4958 16.4958 16.3683 16.5757 16.2115C16.5967 16.1703 16.6281 16.0864 16.6466 15.86C16.6659 15.6239 16.6665 15.3136 16.6665 14.8332V13.3332C16.6665 12.8729 17.0396 12.4998 17.4998 12.4998C17.9601 12.4998 18.3332 12.8729 18.3332 13.3332L18.3332 14.8653V14.8654C18.3332 15.3046 18.3332 15.6836 18.3077 15.9957C18.2808 16.3251 18.2213 16.6528 18.0607 16.9681C17.821 17.4386 17.4386 17.821 16.9681 18.0607C16.6528 18.2213 16.3251 18.2808 15.9957 18.3077C15.6836 18.3332 15.3046 18.3332 14.8654 18.3332H14.8653ZM3.33317 9.1665C2.87293 9.1665 2.49984 9.5396 2.49984 9.99984C2.49984 10.4601 2.87293 10.8332 3.33317 10.8332H16.6665C17.1267 10.8332 17.4998 10.4601 17.4998 9.99984C17.4998 9.5396 17.1267 9.1665 16.6665 9.1665H3.33317Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconContact = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.6665 18.3333C1.6665 14.6513 4.65127 11.6666 8.33317 11.6666C12.0151 11.6666 14.9998 14.6513 14.9998 18.3333H13.3332C13.3332 15.5718 11.0946 13.3333 8.33317 13.3333C5.57175 13.3333 3.33317 15.5718 3.33317 18.3333H1.6665ZM8.33317 10.8333C5.57067 10.8333 3.33317 8.59575 3.33317 5.83325C3.33317 3.07075 5.57067 0.833252 8.33317 0.833252C11.0957 0.833252 13.3332 3.07075 13.3332 5.83325C13.3332 8.59575 11.0957 10.8333 8.33317 10.8333ZM8.33317 9.16658C10.1748 9.16658 11.6665 7.67492 11.6665 5.83325C11.6665 3.99159 10.1748 2.49992 8.33317 2.49992C6.4915 2.49992 4.99984 3.99159 4.99984 5.83325C4.99984 7.67492 6.4915 9.16658 8.33317 9.16658ZM15.2363 12.2523C17.5535 13.2967 19.1665 15.6266 19.1665 18.3333H17.4998C17.4998 16.3033 16.2901 14.5558 14.5522 13.7725L15.2363 12.2523ZM14.6633 2.84426C16.3285 3.53078 17.4998 5.16959 17.4998 7.08325C17.4998 9.47509 15.67 11.4376 13.3332 11.6479V9.97042C14.7471 9.76842 15.8332 8.55325 15.8332 7.08325C15.8332 5.93271 15.1678 4.93828 14.2007 4.46354L14.6633 2.84426Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconArrowRight = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.39275 13.3264C8.13275 13.0664 8.13275 12.6464 8.39275 12.3864L12.7861 7.9931L8.39275 3.60644C8.13275 3.34644 8.13275 2.92644 8.39275 2.66644C8.65275 2.40644 9.07275 2.40644 9.33275 2.66644L14.1928 7.52644C14.4528 7.78644 14.4528 8.20644 14.1928 8.46644L9.33275 13.3264C9.07275 13.5864 8.65275 13.5864 8.39275 13.3264Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconWallet = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.1665 2.5C2.78579 2.5 1.6665 3.61929 1.6665 5V15C1.6665 16.3807 2.78579 17.5 4.1665 17.5H15.8332C17.2139 17.5 18.3332 16.3807 18.3332 15V13.3333C18.7934 13.3333 19.1665 12.9602 19.1665 12.5V7.5C19.1665 7.03976 18.7934 6.66667 18.3332 6.66667V5C18.3332 3.61929 17.2139 2.5 15.8332 2.5H4.1665ZM16.6665 6.66667V5C16.6665 4.53976 16.2934 4.16667 15.8332 4.16667H4.1665C3.70627 4.16667 3.33317 4.53976 3.33317 5V15C3.33317 15.4602 3.70627 15.8333 4.1665 15.8333H15.8332C16.2934 15.8333 16.6665 15.4602 16.6665 15V13.3333H12.4998C10.6589 13.3333 9.1665 11.8409 9.1665 10C9.1665 8.15905 10.6589 6.66667 12.4998 6.66667H16.6665ZM12.4998 8.33333H17.4998V11.6667H12.4998C11.5794 11.6667 10.8332 10.9205 10.8332 10C10.8332 9.07953 11.5794 8.33333 12.4998 8.33333Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconBankCard = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.00488 3H21.0049C21.5572 3 22.0049 3.44771 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44771 2.4526 3 3.00488 3ZM20.0049 11H4.00488V19H20.0049V11ZM20.0049 9V5H4.00488V9H20.0049ZM14.0049 15H18.0049V17H14.0049V15Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconEarn = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M22.5 8.84211C22.5 11.6883 20.7621 14.1287 18.2895 15.1598V15.1579C18.2895 10.2164 14.2836 6.21053 9.34212 6.21053H9.34018C10.3713 3.73795 12.8117 2 15.6579 2C19.4367 2 22.5 5.06332 22.5 8.84211ZM9.34211 22C13.1209 22 16.1842 18.9367 16.1842 15.1579C16.1842 11.3791 13.1209 8.31579 9.34211 8.31579C5.56332 8.31579 2.5 11.3791 2.5 15.1579C2.5 18.9367 5.56332 22 9.34211 22ZM9.34211 12.5263L11.9737 15.1579L9.34211 17.7895L6.71053 15.1579L9.34211 12.5263Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconInvite = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.5 14.252V22H4.5C4.5 17.5817 8.08172 14 12.5 14C13.1906 14 13.8608 14.0875 14.5 14.252ZM12.5 13C9.185 13 6.5 10.315 6.5 7C6.5 3.685 9.185 1 12.5 1C15.815 1 18.5 3.685 18.5 7C18.5 10.315 15.815 13 12.5 13ZM18.5 17V14H20.5V17H23.5V19H20.5V22H18.5V19H15.5V17H18.5Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconGovernment = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.42408 15.303V6.9697H1.6665V5.45455H3.93923V3.9394C3.93923 3.52101 4.27841 3.18182 4.69681 3.18182H15.3029C15.7213 3.18182 16.0604 3.52101 16.0604 3.9394V5.45455H18.3332V6.9697H17.5756V15.303H18.3332V16.8182H1.6665V15.303H2.42408ZM10.7574 15.303V10H9.24226V15.303H10.7574ZM6.96953 15.303V10H5.45438V15.303H6.96953ZM14.5453 15.303V10H13.0301V15.303H14.5453ZM5.45438 4.69698V5.45455H14.5453V4.69698H5.45438Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconBell = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.87532 2.95854C6.96928 1.86458 8.45301 1.25 10.0001 1.25C11.5472 1.25 13.0309 1.86458 14.1249 2.95854C15.2189 4.05251 15.8334 5.53624 15.8334 7.08333C15.8334 9.51056 16.4434 11.1199 17.0829 12.1476L17.0927 12.1634C17.3905 12.6419 17.6259 13.0202 17.7846 13.2956C17.8641 13.4335 17.9366 13.5664 17.9902 13.6845C18.017 13.7435 18.0469 13.8158 18.0703 13.8944C18.0898 13.9596 18.1268 14.0989 18.1129 14.2686C18.1036 14.3826 18.0803 14.5774 17.9685 14.7786C17.8567 14.9798 17.7036 15.1025 17.6118 15.1706C17.4032 15.3253 17.1637 15.3607 17.0837 15.3725L17.08 15.3731C16.9572 15.3913 16.8178 15.4003 16.6772 15.4058C16.3978 15.4167 16.011 15.4167 15.53 15.4167H4.47023C3.98921 15.4167 3.60243 15.4167 3.32305 15.4058C3.18242 15.4003 3.04302 15.3913 2.92018 15.3731L2.91648 15.3725C2.83654 15.3607 2.59702 15.3253 2.38845 15.1706C2.29658 15.1025 2.14347 14.9798 2.03168 14.7786C1.91989 14.5774 1.89664 14.3826 1.88732 14.2686C1.87344 14.0989 1.91045 13.9596 1.92987 13.8944C1.95328 13.8158 1.98323 13.7435 2.01 13.6845C2.06364 13.5664 2.13608 13.4335 2.2156 13.2956C2.37428 13.0202 2.60967 12.6419 2.90742 12.1634L2.91729 12.1476C3.55677 11.1199 4.16677 9.51056 4.16677 7.08333C4.16677 5.53624 4.78136 4.05251 5.87532 2.95854ZM7.50011 17.9167C7.50011 17.4564 7.8732 17.0833 8.33344 17.0833H11.6668C12.127 17.0833 12.5001 17.4564 12.5001 17.9167C12.5001 18.3769 12.127 18.75 11.6668 18.75H8.33344C7.8732 18.75 7.50011 18.3769 7.50011 17.9167Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconQuestion2 = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337ZM10.1402 6.69099C9.75223 6.62445 9.35326 6.69735 9.01393 6.89678C8.67459 7.09621 8.41679 7.4093 8.28618 7.78059C8.13345 8.21475 7.65769 8.4429 7.22353 8.29017C6.78937 8.13744 6.56123 7.66168 6.71395 7.22752C6.97518 6.48493 7.49079 5.85875 8.16946 5.45989C8.84813 5.06103 9.64606 4.91523 10.4219 5.04831C11.1978 5.18139 11.9015 5.58477 12.4085 6.187C12.9153 6.7891 13.1928 7.55112 13.1917 8.33815C13.1914 9.61345 12.2458 10.4556 11.5706 10.9058C11.2076 11.1478 10.8505 11.3257 10.5875 11.4426C10.4548 11.5016 10.343 11.5464 10.2625 11.5771C10.2221 11.5924 10.1895 11.6043 10.1656 11.6128L10.1367 11.6229L10.1275 11.6261L10.1242 11.6272L10.123 11.6276L10.1219 11.628C9.6853 11.7735 9.21337 11.5375 9.06783 11.1009C8.92239 10.6646 9.15794 10.193 9.594 10.0471L9.6073 10.0424C9.62012 10.0379 9.64113 10.0303 9.66916 10.0196C9.72535 9.99818 9.80891 9.96481 9.91057 9.91963C10.1163 9.82821 10.3842 9.69366 10.6461 9.51901C11.2208 9.1359 11.5251 8.72834 11.5251 8.33739L11.5251 8.33615C11.5257 7.94255 11.3869 7.56145 11.1334 7.26033C10.88 6.95922 10.5281 6.75753 10.1402 6.69099ZM10.9256 13.6527C10.9256 14.205 10.4779 14.6527 9.92562 14.6527C9.37333 14.6527 8.92562 14.205 8.92562 13.6527C8.92562 13.1004 9.37333 12.6527 9.92562 12.6527C10.4779 12.6527 10.9256 13.1004 10.9256 13.6527Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSettingLanguage = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.7074 10.8336H6.27234C6.4215 13.5576 7.29746 16.088 8.70963 18.2343C4.98931 17.6562 2.08305 14.6171 1.7074 10.8336ZM1.7074 9.16691C2.08305 5.38333 4.98931 2.34423 8.70963 1.76611C7.29746 3.9124 6.4215 6.44286 6.27234 9.16691H1.7074ZM18.2918 9.16691H13.7268C13.5776 6.44286 12.7017 3.9124 11.2895 1.76611C15.0099 2.34423 17.9161 5.38333 18.2918 9.16691ZM18.2918 10.8336C17.9161 14.6171 15.0099 17.6562 11.2895 18.2343C12.7017 16.088 13.5776 13.5576 13.7268 10.8336H18.2918ZM7.94186 10.8336H12.0573C11.9143 13.1526 11.1785 15.3112 9.99955 17.1598C8.82063 15.3112 8.08487 13.1526 7.94186 10.8336ZM7.94186 9.16691C8.08487 6.84785 8.82063 4.6892 9.99955 2.84061C11.1785 4.6892 11.9143 6.84785 12.0573 9.16691H7.94186Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconService = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_648_5910)">
                    <path
                        d="M17.5002 6.66634C18.4207 6.66634 19.1668 7.41253 19.1668 8.33301V11.6663C19.1668 12.5868 18.4207 13.333 17.5002 13.333H16.6152C16.2052 16.6216 13.3998 19.1663 10.0002 19.1663V17.4997C12.7616 17.4997 15.0002 15.2611 15.0002 12.4997V7.49967C15.0002 4.73825 12.7616 2.49967 10.0002 2.49967C7.23874 2.49967 5.00016 4.73825 5.00016 7.49967V13.333H2.50016C1.57969 13.333 0.833496 12.5868 0.833496 11.6663V8.33301C0.833496 7.41253 1.57969 6.66634 2.50016 6.66634H3.38507C3.79515 3.37775 6.60048 0.833008 10.0002 0.833008C13.3998 0.833008 16.2052 3.37775 16.6152 6.66634H17.5002ZM6.46636 13.1538L7.34981 11.7403C8.11817 12.2215 9.02666 12.4997 10.0002 12.4997C10.9737 12.4997 11.8822 12.2215 12.6505 11.7403L13.534 13.1538C12.5095 13.7954 11.2982 14.1663 10.0002 14.1663C8.70216 14.1663 7.49085 13.7954 6.46636 13.1538Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_648_5910">
                        <rect width="20" height="20" fill="currentColor" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);
export const IconTipL = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 57 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="0.5"
                    width="56"
                    height="56"
                    rx="28"
                    fill="currentColor"
                />
                <path
                    d="M28.5018 31.1537C29.6658 31.1537 30.6094 30.21 30.6094 29.046L30.6094 19.6076C30.6094 18.4436 29.6658 17.5 28.5018 17.5C27.3378 17.5 26.3942 18.4436 26.3942 19.6076L26.3942 29.046C26.3942 30.21 27.3378 31.1537 28.5018 31.1537Z"
                    fill="white"
                />
                <path
                    d="M25.971 35.9709C25.971 34.5741 27.1034 33.4417 28.5002 33.4417C29.897 33.4417 31.0293 34.5741 31.0293 35.9709C31.0293 37.3677 29.897 38.5 28.5002 38.5C27.1034 38.5 25.971 37.3677 25.971 35.9709Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconPeople = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.3334 14.6667H2.66669V13.3333C2.66669 11.4924 4.15907 9.99999 6.00002 9.99999H10C11.841 9.99999 13.3334 11.4924 13.3334 13.3333V14.6667ZM8.00002 8.66666C5.79088 8.66666 4.00002 6.87579 4.00002 4.66666C4.00002 2.45752 5.79088 0.666656 8.00002 0.666656C10.2092 0.666656 12 2.45752 12 4.66666C12 6.87579 10.2092 8.66666 8.00002 8.66666Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconUxuy = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.4208 16.7673C13.4743 16.8298 13.5525 16.8658 13.6347 16.8658H17.2545C17.4949 16.8658 17.6248 16.5838 17.4684 16.4011L12.2736 10.3325C12.183 10.2267 12.1834 10.0706 12.2744 9.96525L19.1037 2.06435C19.2614 1.88193 19.1318 1.59863 18.8907 1.59863H15.2741C15.1923 1.59863 15.1145 1.63426 15.061 1.69623L7.91803 9.97223C7.82708 10.0776 7.82677 10.2336 7.9173 10.3393L13.4208 16.7673Z"
                    fill="#FF4702"
                />
                <path
                    d="M6.60153 16.7681C6.54804 16.8303 6.47008 16.866 6.38805 16.866H2.76984C2.52904 16.866 2.39934 16.5834 2.55636 16.4008L7.77559 10.333C7.8664 10.2275 7.8664 10.0714 7.7756 9.96581L2.55631 3.89732C2.3993 3.71476 2.529 3.43213 2.7698 3.43213H6.38804C6.47008 3.43213 6.54804 3.4679 6.60153 3.5301L12.1367 9.96581C12.2275 10.0714 12.2275 10.2275 12.1366 10.333L6.60153 16.7681Z"
                    fill="#FF7400"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconPending = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.33769 3.12147V7.98533L12.7852 11.4362C13.3145 11.9661 13.3145 12.822 12.7852 13.3519C12.2558 13.8817 11.4008 13.8817 10.8714 13.3519L7.03033 9.50698C6.77245 9.24884 6.63672 8.90919 6.63672 8.54236V3.10789C6.63672 2.36065 7.24749 1.74927 7.99399 1.74927C8.74049 1.74927 9.35127 2.36065 9.35127 3.10789L9.33769 3.12147Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconBtc = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 49 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="24.5" cy="24" r="24" fill="#FF7400" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32.0812 24.7952C33.6029 24.412 34.5562 23.4514 34.9591 21.9206C35.4805 19.9396 34.9478 18.3894 33.3047 17.1827C32.4412 16.5484 31.4721 16.1215 30.4711 15.7643C30.2801 15.6962 30.2368 15.6131 30.2831 15.434C30.456 14.7648 30.6249 14.0946 30.7927 13.4242C30.8907 13.0328 30.987 12.6409 31.0858 12.2394C31.1305 12.0572 31.1758 11.873 31.222 11.6859L28.8116 11.0858L27.8405 14.9664L25.8855 14.5016L26.8558 10.5974L24.4592 10C24.447 10.0363 24.4354 10.0689 24.4246 10.0992C24.4037 10.1576 24.386 10.2074 24.3733 10.2584C24.3118 10.5044 24.2501 10.7504 24.1884 10.9964C23.9605 11.9048 23.7326 12.8132 23.5159 13.7243C23.4643 13.9415 23.3924 13.9793 23.1824 13.9239C22.5245 13.7503 21.8636 13.588 21.2027 13.4256C21.0241 13.3817 20.8455 13.3379 20.667 13.2938C20.1739 13.172 19.6805 13.0514 19.1805 12.9292C18.972 12.8782 18.7622 12.827 18.5509 12.7752L17.9092 15.3459C17.9778 15.3625 18.0448 15.3782 18.1106 15.3936C18.2497 15.4261 18.3834 15.4573 18.5155 15.4941C18.6661 15.5362 18.8181 15.5752 18.9701 15.6141C19.351 15.7118 19.7321 15.8094 20.093 15.9563C20.6676 16.1903 20.9035 16.7761 20.7547 17.3758C20.6286 17.884 20.5027 18.3922 20.3768 18.9004C20.1091 19.9806 19.8415 21.0609 19.5723 22.1407C19.4148 22.7724 19.2563 23.4039 19.0978 24.0354C18.764 25.3652 18.4302 26.6951 18.1058 28.0271C17.9992 28.4645 17.5172 28.8783 17.0026 28.7286C16.591 28.609 16.1716 28.5165 15.7478 28.4231C15.5625 28.3823 15.3763 28.3413 15.1897 28.2977L14 31.04L18.8883 32.2766L17.8861 36.3153L20.2833 36.9108C20.2957 36.8646 20.3071 36.823 20.3177 36.7843C20.3383 36.7092 20.3559 36.6453 20.372 36.581C20.4297 36.3515 20.4874 36.1219 20.5451 35.8924C20.7747 34.9793 21.0042 34.0663 21.2287 33.152C21.2635 33.0103 21.3032 32.9199 21.4682 32.9639C21.9178 33.0837 22.3674 33.2031 22.8343 33.3271C22.9665 33.3622 23.1002 33.3977 23.2356 33.4337L22.252 37.4042L24.6443 38C24.6559 37.9654 24.6672 37.934 24.6778 37.9045C24.6987 37.8463 24.7169 37.7957 24.7298 37.7439C24.7871 37.5139 24.8446 37.2839 24.9021 37.054C25.1353 36.1206 25.3686 35.1873 25.5924 34.2517C25.644 34.0361 25.7232 33.9637 25.9455 34.0189C26.1051 34.0585 26.2688 34.0809 26.4326 34.1033C26.5113 34.1141 26.5899 34.1248 26.6681 34.1375C27.9158 34.3393 29.1671 34.4129 30.4176 34.181C31.5468 33.9717 32.5133 33.4662 33.2371 32.5474C34.0157 31.5592 34.4159 30.4205 34.5872 29.1885C34.7629 27.9246 34.4439 26.8094 33.5187 25.9205C33.2198 25.6334 32.882 25.3867 32.5424 25.1386C32.3879 25.0257 32.233 24.9126 32.0812 24.7952ZM25.2386 22.5387C26.3138 22.7931 27.3944 22.9894 28.5064 22.8104C30.1179 22.5511 30.5944 21.1318 30.3249 20.0978C30.1348 19.3686 29.5965 18.9142 28.9682 18.5565C27.9885 17.9987 26.9084 17.7477 25.8284 17.4966C25.6911 17.4647 25.5534 17.4327 25.4163 17.4002C25.2316 17.3564 25.1991 17.4737 25.1647 17.6163C25.0676 18.0191 24.9665 18.421 24.8654 18.8229C24.8105 19.0413 24.7555 19.2597 24.7012 19.4783C24.5463 20.1017 24.3921 20.7252 24.2353 21.3588L24.0206 22.2263C24.1599 22.2622 24.2947 22.2976 24.4265 22.3323C24.7055 22.4056 24.9713 22.4754 25.2386 22.5387ZM22.9753 26.4052C22.6885 27.5496 22.4017 28.694 22.1124 29.8377C22.0687 30.0107 22.1432 30.0413 22.2899 30.0732C22.6279 30.1468 22.9648 30.2263 23.3018 30.3057C23.9345 30.455 24.5672 30.6042 25.2067 30.7141C26.0831 30.8645 26.9745 30.8865 27.857 30.6812C29.5934 30.2771 30.0955 28.3416 29.2342 27.1718C28.8301 26.6229 28.2825 26.2511 27.6808 25.9533C26.4875 25.3624 25.2042 25.0683 23.9244 24.7749C23.7636 24.7381 23.6029 24.7012 23.4424 24.6638C23.4351 24.673 23.4279 24.6806 23.4215 24.6875C23.4096 24.7002 23.4004 24.71 23.3975 24.7215C23.2567 25.2819 23.1163 25.8424 22.9758 26.403L22.9753 26.4052Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconBtc2 = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="10" cy="10" r="10" fill="#FF7400" />
                <path
                    d="M10.7477 13.9884L10.337 15.5361C10.3352 15.5428 10.3308 15.5485 10.3248 15.5519C10.3187 15.5553 10.3115 15.5562 10.3047 15.5544L9.33826 15.298C9.32059 15.2932 9.31416 15.2821 9.31898 15.2647L9.69544 13.8645C9.69724 13.8579 9.6977 13.8511 9.6968 13.8443C9.6959 13.8376 9.69365 13.8311 9.69018 13.8253C9.68672 13.8194 9.68211 13.8143 9.67664 13.8103C9.67116 13.8063 9.66493 13.8034 9.65832 13.8018L8.85576 13.6148C8.84759 13.6129 8.83899 13.6142 8.83179 13.6186C8.8246 13.6229 8.81936 13.6298 8.8172 13.6379L8.44991 15.018C8.44284 15.0446 8.42597 15.0544 8.39929 15.0474L7.45984 14.7919C7.44949 14.7891 7.44069 14.7823 7.43535 14.7729C7.43002 14.7636 7.4286 14.7526 7.43141 14.7422L7.80063 13.3704C7.80723 13.3459 7.8044 13.3199 7.79271 13.2974C7.78101 13.2749 7.76131 13.2576 7.73749 13.249C6.96915 12.9703 6.25046 12.5974 5.58143 12.1302C5.57462 12.1255 5.56886 12.1194 5.56452 12.1124C5.56018 12.1053 5.55736 12.0974 5.55623 12.0892C5.55509 12.081 5.55568 12.0727 5.55794 12.0647C5.5602 12.0567 5.5641 12.0493 5.56938 12.0429L6.37724 11.0577C6.38536 11.0478 6.39695 11.0413 6.40965 11.0396C6.42236 11.0379 6.43523 11.0411 6.44568 11.0485C7.57938 11.8617 9.05194 12.5288 10.4724 12.523C10.9737 12.5206 11.5411 12.4257 11.665 11.8636C11.785 11.319 11.0648 10.8148 10.633 10.5786C9.93403 10.1968 9.47307 9.94762 9.25005 9.83097C8.29807 9.33401 6.72188 8.31166 6.97686 6.99864C7.12532 6.23449 7.60043 5.75344 8.40219 5.55549C8.88067 5.43755 9.3667 5.39964 9.86029 5.44173C9.87769 5.44322 9.89505 5.43853 9.90934 5.42848C9.92362 5.41843 9.9339 5.40366 9.93837 5.38678L10.324 3.9388C10.3352 3.89671 10.3619 3.88112 10.404 3.89205L11.3304 4.13547C11.3526 4.14125 11.3606 4.15523 11.3545 4.1774L10.9781 5.57236C10.9768 5.57689 10.9765 5.58163 10.9771 5.58628C10.9777 5.59094 10.9792 5.59542 10.9815 5.59947C10.9839 5.60351 10.987 5.60704 10.9907 5.60983C10.9944 5.61263 10.9986 5.61463 11.0031 5.61574L11.7908 5.81819C11.8062 5.82204 11.8226 5.81971 11.8363 5.81168C11.85 5.80365 11.86 5.79058 11.864 5.77529L12.226 4.41407C12.2285 4.40528 12.2343 4.39782 12.2423 4.39331C12.2502 4.3888 12.2596 4.3876 12.2684 4.38997L13.1905 4.63628C13.2313 4.64721 13.2463 4.67292 13.2354 4.7134L12.8599 6.12186C12.8557 6.13744 12.8575 6.15403 12.8649 6.16843C12.8723 6.18284 12.8847 6.19406 12.8999 6.19994C13.5056 6.43645 14.0779 6.73707 14.6168 7.1018C14.6222 7.1055 14.6268 7.1103 14.6302 7.11589C14.6337 7.12147 14.6359 7.12772 14.6368 7.13422C14.6376 7.14072 14.6371 7.14733 14.6353 7.15362C14.6334 7.15991 14.6302 7.16574 14.626 7.17072L13.8379 8.09475C13.8299 8.1043 13.8186 8.11063 13.8062 8.11257C13.7938 8.11452 13.7811 8.11196 13.7704 8.10535C12.9654 7.60856 12.1095 7.23756 11.2027 6.99238C10.6739 6.8497 9.45443 6.65545 9.1657 7.28352C8.83697 7.99738 10.0531 8.66064 10.5602 8.93153C11.2443 9.29722 11.7562 9.5845 12.0959 9.79338C12.8083 10.2315 13.7622 10.9931 13.8205 11.8742C13.9165 13.3285 12.5837 13.9575 11.3516 13.9594C11.164 13.9598 10.9754 13.9596 10.7858 13.959C10.7771 13.959 10.7686 13.9619 10.7617 13.9672C10.7548 13.9725 10.7499 13.98 10.7477 13.9884Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconErrorPlace = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 33 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27.5032 28.8966C27.7698 29.15 28.1032 29.2833 28.4498 29.2833V29.27C28.7965 29.27 29.1298 29.15 29.3965 28.8833C29.9165 28.3633 29.9165 27.5233 29.3965 27.0033L5.44984 3.05663C4.92984 2.53663 4.0765 2.53663 3.5565 3.05663C3.0365 3.57663 3.0365 4.42996 3.5565 4.94996L5.66134 7.0548C4.80014 7.8805 4.31494 8.81784 4.31494 9.81642V23.1497C4.31494 26.4697 9.68828 29.1498 16.3149 29.1498C20.0421 29.1498 23.3699 28.296 25.5661 26.9595L27.5032 28.8966ZM23.6047 24.9982L20.675 22.0684C19.3225 22.3362 17.8498 22.4831 16.3016 22.4831C12.5283 22.4831 9.16827 21.6164 6.96827 20.2564V23.1497C6.96827 23.5631 7.58161 24.2964 9.00828 25.0031C10.8483 25.9231 13.4749 26.4831 16.3016 26.4831C19.1283 26.4831 21.7549 25.9231 23.5949 25.0031C23.5982 25.0015 23.6015 24.9998 23.6047 24.9982ZM18.32 19.7135L14.3438 15.7373C11.3768 15.4947 8.77945 14.7094 6.96827 13.5898V16.4831C6.96827 16.8964 7.58161 17.6298 9.00828 18.3364C10.8483 19.2564 13.4749 19.8164 16.3016 19.8164C16.9909 19.8164 17.6659 19.7806 18.32 19.7135ZM11.0556 12.449L7.53198 8.92543C7.14579 9.27906 6.96827 9.59405 6.96827 9.81642C6.96827 10.2298 7.58161 10.9631 9.00828 11.6698C9.61336 11.9747 10.3028 12.2357 11.0556 12.449Z"
                    fill="currentColor"
                />
                <path
                    d="M12.928 6.77637C13.9946 6.60303 15.128 6.48303 16.3013 6.48303C19.128 6.48303 21.7546 7.04303 23.5946 7.96303C25.0213 8.6697 25.6346 9.40303 25.6346 9.81637C25.6346 10.2297 25.0213 10.963 23.5946 11.6697C22.3813 12.283 20.808 12.7097 19.088 12.9364L21.3946 15.243C23.048 14.8564 24.5013 14.283 25.6346 13.5897V16.483C25.6346 16.843 25.1813 17.4164 24.168 18.0297L28.3013 22.163V9.81637C28.3013 6.49637 22.928 3.81637 16.3013 3.81637C14.2613 3.81637 12.3413 4.0697 10.6613 4.52303L12.9146 6.77637H12.928Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconFilter = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20 5V16H23L19 21L15 16H18V5C18 4.4 18.4 4 19 4C19.6 4 20 4.4 20 5ZM12 19C12 19.6 11.6 20 11 20H4C3.4 20 3 19.6 3 19C3 18.4 3.4 18 4 18H11C11.6 18 12 18.4 12 19ZM14 12C14 12.6 13.6 13 13 13H4C3.4 13 3 12.6 3 12C3 11.4 3.4 11 4 11H13C13.6 11 14 11.4 14 12ZM14 5C14 5.6 13.6 6 13 6H4C3.4 6 3 5.6 3 5C3 4.4 3.4 4 4 4H13C13.6 4 14 4.4 14 5Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconSelect = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1827 3.32544C14.6058 3.75935 14.6058 4.46287 14.1827 4.89679L6.59937 12.6746C6.1763 13.1085 5.49037 13.1085 5.0673 12.6746L1.8173 9.34123C1.39423 8.90731 1.39423 8.2038 1.8173 7.76988C2.24037 7.33597 2.9263 7.33597 3.34937 7.76988L5.83333 10.3175L12.6506 3.32544C13.0737 2.89152 13.7596 2.89152 14.1827 3.32544Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconCopperCash = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.5 6.63158C16.5 8.76624 15.1966 10.5966 13.3421 11.3698V11.3684C13.3421 7.66232 10.3377 4.65789 6.63159 4.65789H6.63013C7.40347 2.80346 9.23376 1.5 11.3684 1.5C14.2026 1.5 16.5 3.79749 16.5 6.63158ZM6.63158 16.5C9.46571 16.5 11.7632 14.2026 11.7632 11.3684C11.7632 8.53429 9.46571 6.23684 6.63158 6.23684C3.79749 6.23684 1.5 8.53429 1.5 11.3684C1.5 14.2026 3.79749 16.5 6.63158 16.5ZM6.63158 9.39474L8.60526 11.3684L6.63158 13.3421L4.65789 11.3684L6.63158 9.39474Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconPayment = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.97733 1.60107H6.04827C6.61716 1.60106 7.09698 1.60105 7.48854 1.63607C7.89892 1.67277 8.29051 1.75288 8.65622 1.96123C9.07088 2.19748 9.41654 2.53805 9.65741 2.94976C9.87061 3.31418 9.95256 3.70481 9.99001 4.11249C10.0256 4.50034 10.0256 4.97509 10.0256 5.53548V5.60786C10.0256 6.16825 10.0256 6.643 9.99001 7.03084C9.95256 7.43852 9.87061 7.82916 9.65741 8.19358C9.41654 8.60528 9.07088 8.94585 8.65622 9.1821C8.29051 9.39046 7.89892 9.47057 7.48854 9.50727C7.09699 9.54229 6.61717 9.54228 6.04828 9.54226H5.97731C5.40843 9.54228 4.92861 9.54229 4.53706 9.50727C4.12668 9.47057 3.73508 9.39046 3.36938 9.1821C2.95472 8.94585 2.60906 8.60528 2.36819 8.19358C2.15498 7.82916 2.07303 7.43852 2.03559 7.03084C1.99997 6.64299 1.99998 6.16823 2 5.60783V5.53551C1.99998 4.97511 1.99997 4.50035 2.03559 4.1125C2.07303 3.70482 2.15498 3.31418 2.36819 2.94976C2.60906 2.53805 2.95472 2.19748 3.36938 1.96123C3.73508 1.75288 4.12668 1.67277 4.53706 1.63607C4.92861 1.60105 5.40843 1.60106 5.97733 1.60107ZM4.68096 3.24495C4.38065 3.27181 4.24957 3.31883 4.16902 3.36473C3.99898 3.4616 3.85911 3.60017 3.76241 3.76546C3.71797 3.84142 3.6711 3.96659 3.64413 4.26023C3.6161 4.56538 3.61531 4.96538 3.61531 5.57167C3.61531 6.17796 3.6161 6.57796 3.64413 6.88311C3.6711 7.17675 3.71797 7.30192 3.76241 7.37788C3.85911 7.54316 3.99898 7.68173 4.16902 7.77861C4.24957 7.8245 4.38065 7.87153 4.68096 7.89839C4.99197 7.9262 5.39901 7.92696 6.0128 7.92696C6.62659 7.92696 7.03363 7.9262 7.34464 7.89839C7.64494 7.87153 7.77603 7.8245 7.85658 7.77861C8.02662 7.68173 8.16649 7.54316 8.26319 7.37788C8.30763 7.30192 8.3545 7.17675 8.38147 6.88311C8.4095 6.57796 8.41029 6.17796 8.41029 5.57167C8.41029 4.96538 8.4095 4.56538 8.38147 4.26023C8.3545 3.96659 8.30763 3.84142 8.26319 3.76546C8.16649 3.60017 8.02662 3.4616 7.85658 3.36473C7.77603 3.31883 7.64495 3.27181 7.34464 3.24495C7.03363 3.21713 6.62659 3.21638 6.0128 3.21638C5.39901 3.21638 4.99197 3.21713 4.68096 3.24495ZM14.9517 1.60107H15.0227C15.5916 1.60106 16.0714 1.60105 16.4629 1.63607C16.8733 1.67277 17.2649 1.75288 17.6306 1.96123C18.0453 2.19748 18.3909 2.53805 18.6318 2.94976C18.845 3.31418 18.927 3.70481 18.9644 4.11249C19 4.50035 19 4.97511 19 5.53552V5.60782C19 6.16823 19 6.64299 18.9644 7.03084C18.927 7.43852 18.845 7.82916 18.6318 8.19358C18.3909 8.60528 18.0453 8.94585 17.6306 9.1821C17.2649 9.39046 16.8733 9.47057 16.4629 9.50727C16.0714 9.54229 15.5916 9.54228 15.0227 9.54226H14.9517C14.3828 9.54228 13.903 9.54229 13.5115 9.50727C13.1011 9.47057 12.7095 9.39046 12.3438 9.1821C11.9291 8.94585 11.5835 8.60528 11.3426 8.19358C11.1294 7.82916 11.0474 7.43852 11.01 7.03084C10.9744 6.64299 10.9744 6.16823 10.9744 5.60782V5.53552C10.9744 4.97511 10.9744 4.50035 11.01 4.11249C11.0474 3.70481 11.1294 3.31418 11.3426 2.94976C11.5835 2.53805 11.9291 2.19748 12.3438 1.96123C12.7095 1.75288 13.1011 1.67277 13.5115 1.63607C13.903 1.60105 14.3828 1.60106 14.9517 1.60107ZM13.6554 3.24495C13.3551 3.27181 13.224 3.31883 13.1434 3.36473C12.9734 3.4616 12.8335 3.60017 12.7368 3.76546C12.6924 3.84142 12.6455 3.96659 12.6185 4.26023C12.5905 4.56538 12.5897 4.96538 12.5897 5.57167C12.5897 6.17796 12.5905 6.57795 12.6185 6.88311C12.6455 7.17675 12.6924 7.30192 12.7368 7.37788C12.8335 7.54317 12.9734 7.68173 13.1434 7.77861C13.224 7.8245 13.3551 7.87153 13.6554 7.89839C13.9664 7.9262 14.3734 7.92696 14.9872 7.92696C15.601 7.92696 16.008 7.9262 16.319 7.89839C16.6193 7.87153 16.7504 7.8245 16.831 7.77861C17.001 7.68174 17.1409 7.54317 17.2376 7.37788C17.282 7.30192 17.3289 7.17675 17.3559 6.88311C17.3839 6.57795 17.3847 6.17796 17.3847 5.57167C17.3847 4.96538 17.3839 4.56538 17.3559 4.26023C17.3289 3.96659 17.282 3.84142 17.2376 3.76546C17.1409 3.60017 17.001 3.4616 16.831 3.36473C16.7504 3.31883 16.6193 3.27181 16.319 3.24495C16.008 3.21713 15.601 3.21638 14.9872 3.21638C14.3734 3.21638 13.9664 3.21713 13.6554 3.24495ZM5.97731 10.4573H6.04828C6.61717 10.4573 7.09699 10.4573 7.48854 10.4923C7.89892 10.529 8.29051 10.6091 8.65622 10.8175C9.07088 11.0537 9.41654 11.3943 9.65741 11.806C9.87061 12.1704 9.95256 12.561 9.99001 12.9687C10.0256 13.3566 10.0256 13.8313 10.0256 14.3917V14.4641C10.0256 15.0245 10.0256 15.4992 9.99001 15.8871C9.95256 16.2948 9.87061 16.6854 9.65741 17.0498C9.41654 17.4615 9.07088 17.8021 8.65622 18.0383C8.29051 18.2467 7.89892 18.3268 7.48854 18.3635C7.09698 18.3985 6.61715 18.3985 6.04825 18.3985H5.97735C5.40845 18.3985 4.92862 18.3985 4.53706 18.3635C4.12668 18.3268 3.73508 18.2467 3.36938 18.0383C2.95472 17.8021 2.60906 17.4615 2.36819 17.0498C2.15498 16.6854 2.07303 16.2948 2.03559 15.8871C1.99997 15.4992 1.99998 15.0245 2 14.4641V14.3917C1.99998 13.8313 1.99997 13.3566 2.03559 12.9687C2.07303 12.561 2.15498 12.1704 2.36819 11.806C2.60906 11.3943 2.95472 11.0537 3.36938 10.8175C3.73508 10.6091 4.12668 10.529 4.53706 10.4923C4.92861 10.4573 5.40843 10.4573 5.97731 10.4573ZM4.68096 12.1012C4.38065 12.128 4.24957 12.1751 4.16902 12.221C3.99898 12.3178 3.85911 12.4564 3.76241 12.6217C3.71797 12.6977 3.6711 12.8228 3.64413 13.1165C3.6161 13.4216 3.61531 13.8216 3.61531 14.4279C3.61531 15.0342 3.6161 15.4342 3.64413 15.7393C3.6711 16.033 3.71797 16.1582 3.76241 16.2341C3.85911 16.3994 3.99898 16.538 4.16902 16.6348C4.24957 16.6807 4.38065 16.7278 4.68096 16.7546C4.99197 16.7824 5.39901 16.7832 6.0128 16.7832C6.62658 16.7832 7.03363 16.7824 7.34464 16.7546C7.64494 16.7278 7.77603 16.6807 7.85658 16.6348C8.02662 16.538 8.16649 16.3994 8.26319 16.2341C8.30763 16.1582 8.3545 16.033 8.38147 15.7393C8.4095 15.4342 8.41029 15.0342 8.41029 14.4279C8.41029 13.8216 8.4095 13.4216 8.38147 13.1165C8.3545 12.8228 8.30763 12.6977 8.26319 12.6217C8.16649 12.4564 8.02662 12.3178 7.85658 12.221C7.77603 12.1751 7.64494 12.128 7.34464 12.1012C7.03363 12.0734 6.62658 12.0726 6.0128 12.0726C5.39901 12.0726 4.99197 12.0734 4.68096 12.1012Z"
                    fill="#FF7400"
                />
                <path
                    d="M12.9613 11.5125C13.4711 11.5125 13.8844 11.9203 13.8844 12.4234C13.8844 12.9265 13.4711 13.3344 12.9613 13.3344C12.4515 13.3344 12.0382 12.9265 12.0382 12.4234C12.0382 11.9203 12.4515 11.5125 12.9613 11.5125Z"
                    fill="#FF7400"
                />
                <path
                    d="M15.1152 13.638C15.625 13.638 16.0382 14.0458 16.0382 14.5489C16.0382 15.052 15.625 15.4599 15.1152 15.4599C14.6054 15.4599 14.1921 15.052 14.1921 14.5489C14.1921 14.0458 14.6054 13.638 15.1152 13.638Z"
                    fill="#FF7400"
                />
                <path
                    d="M17.269 11.5125C17.7788 11.5125 18.1921 11.9203 18.1921 12.4234C18.1921 12.9265 17.7788 13.3344 17.269 13.3344C16.7592 13.3344 16.3459 12.9265 16.3459 12.4234C16.3459 11.9203 16.7592 11.5125 17.269 11.5125Z"
                    fill="#FF7400"
                />
                <path
                    d="M12.9613 15.7635C13.4711 15.7635 13.8844 16.1714 13.8844 16.6744C13.8844 17.1775 13.4711 17.5854 12.9613 17.5854C12.4515 17.5854 12.0382 17.1775 12.0382 16.6744C12.0382 16.1714 12.4515 15.7635 12.9613 15.7635Z"
                    fill="#FF7400"
                />
                <path
                    d="M17.269 15.7635C17.7788 15.7635 18.1921 16.1714 18.1921 16.6744C18.1921 17.1775 17.7788 17.5854 17.269 17.5854C16.7592 17.5854 16.3459 17.1775 16.3459 16.6744C16.3459 16.1714 16.7592 15.7635 17.269 15.7635Z"
                    fill="#FF7400"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconInviteDesc_1 = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.9461 2.0946C12.8248 1.13904 11.1756 1.13905 10.0544 2.09459L8.70636 3.24335C8.54619 3.37984 8.34705 3.46232 8.13728 3.47906L6.3718 3.61995C4.90327 3.73714 3.73714 4.90327 3.61995 6.37179L3.47907 8.13727C3.46234 8.34703 3.37983 8.54622 3.24334 8.70638L2.09458 10.0544C1.13904 11.1757 1.13905 12.8248 2.0946 13.946L3.24336 15.2941C3.37983 15.4543 3.46232 15.6534 3.47906 15.8632L3.61997 17.6286C3.73716 19.0971 4.9033 20.2632 6.37184 20.3804L8.13729 20.5214C8.34705 20.5381 8.54615 20.6206 8.70631 20.7571L10.0543 21.9058C11.1756 22.8613 12.8248 22.8614 13.9461 21.9058L15.2941 20.7571C15.4542 20.6206 15.6533 20.5381 15.8631 20.5213L17.6286 20.3804C19.0971 20.2633 20.2632 19.0972 20.3805 17.6286L20.5213 15.8632C20.538 15.6534 20.6206 15.4542 20.757 15.294L21.9058 13.9461C22.8614 12.8248 22.8614 11.1756 21.9058 10.0544L20.757 8.70634C20.6205 8.54617 20.5381 8.34703 20.5214 8.13728L20.3805 6.3718C20.2633 4.90329 19.0971 3.73712 17.6286 3.61994L15.8631 3.47905C15.6533 3.46231 15.4542 3.37984 15.2941 3.24335L13.9461 2.0946ZM14.8284 7.75767L16.2426 9.17189L9.17151 16.243L7.7573 14.8287L14.8284 7.75767ZM10.2322 10.2325C9.64638 10.8183 8.69664 10.8183 8.11085 10.2325C7.52506 9.64679 7.52506 8.69701 8.11085 8.11122C8.69664 7.52543 9.64638 7.52543 10.2322 8.11122C10.818 8.69701 10.818 9.64679 10.2322 10.2325ZM13.7677 15.8894C13.1819 15.3036 13.1819 14.3539 13.7677 13.7681C14.3535 13.1823 15.3032 13.1823 15.889 13.7681C16.4748 14.3539 16.4748 15.3036 15.889 15.8894C15.3032 16.4752 14.3535 16.4752 13.7677 15.8894Z"
                    fill="#FF7400"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconInviteDesc_2 = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.03809 9.96231C4.03809 5.56485 7.60293 2 12.0004 2C16.3979 2 19.9627 5.56485 19.9627 9.96231L16.4384 13.9626C15.9875 13.4672 15.4548 13.0475 14.8616 12.7251L17.3486 9.89767C17.3486 9.89767 16.9576 8.44727 15.1369 8.44727C13.3163 8.44727 12.997 9.89767 12.997 9.89767V12.0824C12.6727 12.0282 12.3397 12 12 12C11.6614 12 11.3293 12.0281 11.006 12.082V9.89767C11.006 9.89767 10.6866 8.44727 8.86601 8.44727C7.04537 8.44727 6.6543 9.89767 6.6543 9.89767L9.14037 12.724C8.54656 13.0465 8.0133 13.4664 7.56197 13.9621L4.03809 9.96231Z"
                    fill="#FF7400"
                />
                <path
                    d="M16 18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18C8 15.7909 9.79086 14 12 14C14.2091 14 16 15.7909 16 18Z"
                    fill="#FF7400"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconInviteDesc_3 = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5ZM7 3C4.79086 3 3 4.79086 3 7V9H5V7C5 5.89543 5.89543 5 7 5H10V3H7ZM17 21C19.2091 21 21 19.2091 21 17V15H19V17C19 18.1046 18.1046 19 17 19H14V21H17ZM7 16C8.65685 16 10 14.6569 10 13C10 11.3431 8.65685 10 7 10C5.34315 10 4 11.3431 4 13C4 14.6569 5.34315 16 7 16ZM17 9C14.7909 9 13 10.7909 13 13H21C21 10.7909 19.2091 9 17 9ZM3 21C3 18.7909 4.79086 17 7 17C9.20914 17 11 18.7909 11 21H3Z"
                    fill="#FF7400"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconInviteDesc_4 = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.0049 22.0029C6.48204 22.0029 2.00488 17.5258 2.00488 12.0029C2.00488 6.48008 6.48204 2.00293 12.0049 2.00293C17.5277 2.00293 22.0049 6.48008 22.0049 12.0029C22.0049 17.5258 17.5277 22.0029 12.0049 22.0029ZM9.50488 9.00293L7.00488 11.5029L12.0041 16.5029L17.0049 11.5029L14.5049 9.00293H9.50488Z"
                    fill="#FF7400"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconBotSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.99919 3.33301C7.0797 3.33301 4.71289 5.71329 4.71289 8.64948V13.3405C4.71289 14.895 5.96584 16.1551 7.51152 16.1551H12.4869C14.0325 16.1551 15.2855 14.895 15.2855 13.3405V8.64948C15.2855 5.71329 12.9187 3.33301 9.99919 3.33301ZM13.7307 8.64948C13.7307 9.6272 12.7693 10.2132 11.7971 10.2132H8.20131C7.22911 10.2132 6.26768 9.6272 6.26768 8.64948C6.26768 6.57686 7.93833 4.89668 9.99919 4.89668C12.0601 4.89668 13.7307 6.57686 13.7307 8.64948Z"
                    fill="currentColor"
                />
                <rect
                    x="16.0732"
                    y="8.84375"
                    width="3.09305"
                    height="5.7362"
                    rx="1.54652"
                    fill="currentColor"
                />
                <rect
                    x="0.833008"
                    y="8.84375"
                    width="3.09305"
                    height="5.7362"
                    rx="1.54652"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconLinkSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.4667 7.34999L11.9334 7.81666C14.2834 10.1667 14.2834 13.9667 11.9334 16.3167C9.75836 18.4917 6.23336 18.8083 3.88336 16.825C1.53336 14.8417 1.15836 11.3667 2.8917 8.95833C3.18336 8.54999 3.7917 8.51666 4.15003 8.87499C4.4417 9.16666 4.4667 9.61666 4.23336 9.94999C2.9667 11.7333 3.27503 14.3 5.15836 15.7083C6.75003 16.9 9.30836 16.5833 10.7084 15.175L10.7667 15.1167C12.4584 13.425 12.4584 10.7 10.775 9.01666L10.2834 8.52499C9.95836 8.19999 9.95836 7.67499 10.2834 7.34999C10.6084 7.02499 11.1334 7.02499 11.4584 7.34999H11.4667ZM15.8334 11.125C15.5417 10.8333 15.5167 10.3833 15.75 10.05C16.9417 8.36666 16.7417 5.99999 15.1417 4.54999C13.5417 3.09999 10.8167 3.27499 9.27503 4.82499L9.13336 4.96666C7.48336 6.61666 7.48336 9.24999 9.1167 10.8833L9.70836 11.475C10.0334 11.8 10.0334 12.325 9.70836 12.65C9.38336 12.975 8.85836 12.975 8.53336 12.65L8.0667 12.1833C5.7167 9.83333 5.7167 6.03333 8.0667 3.68333C10.2417 1.50833 13.7667 1.19166 16.1167 3.17499C18.4667 5.15833 18.8417 8.63333 17.1084 11.0417C16.8167 11.45 16.2084 11.4833 15.85 11.125H15.8334Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconShareSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.0003 11.6667H8.33366C5.45201 11.6667 2.94993 13.2918 1.69398 15.6756C1.6761 15.4527 1.66699 15.2274 1.66699 15C1.66699 10.3977 5.39795 6.66667 10.0003 6.66667V3.54031C10.0003 3.12106 10.4853 2.88797 10.8127 3.14988L17.3576 8.3858C17.858 8.78612 17.858 9.54721 17.3576 9.94754L10.8127 15.1835C10.4853 15.4454 10.0003 15.2123 10.0003 14.793V11.6667Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconShareOutline = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.78209 12.6147H8.03881C5.02469 12.6147 2.40759 14.3146 1.09391 16.8079C1.0752 16.5748 1.06567 16.3391 1.06567 16.1013C1.06567 11.2874 4.96815 7.38485 9.78209 7.38485V3.63888C9.78209 3.21828 10.2698 2.98562 10.5967 3.25026L17.9742 9.22253C18.4686 9.62276 18.4686 10.3768 17.9742 10.777L10.5967 16.7493C10.2698 17.0139 9.78209 16.7813 9.78209 16.3607V12.6147ZM8.03881 10.8714H10.5254C11.0777 10.8714 11.5254 11.3191 11.5254 11.8714V13.7546L16.1637 9.99978L11.5254 6.24495V8.12813C11.5254 8.68042 11.0777 9.12813 10.5254 9.12813H9.78209C7.67228 9.12813 5.78135 10.0651 4.50266 11.5456C5.60582 11.108 6.80143 10.8714 8.03881 10.8714Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconShareHollowSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.78209 12.6149H8.03881C5.02469 12.6149 2.40759 14.3148 1.09391 16.8082C1.0752 16.5751 1.06567 16.3394 1.06567 16.1015C1.06567 11.2876 4.96815 7.38509 9.78209 7.38509V3.63912C9.78209 3.21852 10.2698 2.98586 10.5967 3.2505L17.9742 9.22278C18.4686 9.62301 18.4686 10.377 17.9742 10.7773L10.5967 16.7495C10.2698 17.0142 9.78209 16.7815 9.78209 16.3609V12.6149ZM8.03881 10.8717H10.5254C11.0777 10.8717 11.5254 11.3194 11.5254 11.8717V13.7549L16.1637 10L11.5254 6.2452V8.12838C11.5254 8.68066 11.0777 9.12838 10.5254 9.12838H9.78209C7.67228 9.12838 5.78135 10.0653 4.50266 11.5459C5.60582 11.1082 6.80143 10.8717 8.03881 10.8717Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconTgSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M17.4921 4.30719C17.4494 4.90374 17.1086 6.99152 16.7677 9.24985C16.2564 12.446 15.7025 15.9393 15.7025 15.9393C15.7025 15.9393 15.6173 16.9194 14.8929 17.0898C14.1685 17.2603 12.9756 16.4933 12.7626 16.3232C12.5921 16.1954 9.56697 14.2779 8.45915 13.3406C8.16088 13.0849 7.82003 12.574 8.50173 11.9771C10.0357 10.571 11.8678 8.82408 12.9756 7.71627C13.487 7.20499 13.9981 6.01191 11.8678 7.46057C8.84258 9.54812 5.85998 11.5084 5.85998 11.5084C5.85998 11.5084 5.17793 11.9342 3.90004 11.5504C2.62216 11.1666 1.13044 10.6556 1.13044 10.6556C1.13044 10.6556 0.107898 10.0165 1.85472 9.33465C1.85472 9.33465 9.226 6.30947 11.7825 5.24423C12.7626 4.81811 16.086 3.4546 16.086 3.4546C16.086 3.4546 17.62 2.85817 17.4921 4.30719Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconXSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14.7723 2.5H17.3169L11.7577 8.85385L18.2977 17.5H13.1769L9.16617 12.2562L4.57697 17.5H2.03082L7.97697 10.7038L1.70312 2.5H6.95389L10.5792 7.29308L14.7723 2.5ZM13.8792 15.9769H15.2892L6.18774 3.94308H4.67466L13.8792 15.9769Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconAddSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 14.6027 5.39795 18.3337 10.0003 18.3337ZM6.75991 10.9256C6.24854 10.9256 5.83398 10.5111 5.83398 9.99972C5.83398 9.48834 6.24854 9.07379 6.75991 9.07379L9.07546 9.07379V6.75991C9.07546 6.24854 9.49001 5.83398 10.0014 5.83398C10.5128 5.83398 10.9273 6.24854 10.9273 6.75991L10.9273 9.07379H13.2414C13.7528 9.07379 14.1673 9.48834 14.1673 9.99972C14.1673 10.5111 13.7528 10.9256 13.2414 10.9256H10.9273V13.2414C10.9273 13.7528 10.5128 14.1673 10.0014 14.1673C9.49001 14.1673 9.07546 13.7528 9.07546 13.2414V10.9256H6.75991Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconToastFailSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.6663 13.9997C25.6663 20.443 20.443 25.6663 13.9997 25.6663C7.55635 25.6663 2.33301 20.443 2.33301 13.9997C2.33301 7.55635 7.55635 2.33301 13.9997 2.33301C20.443 2.33301 25.6663 7.55635 25.6663 13.9997ZM18.0077 16.2252C18.4994 16.7169 18.4994 17.5141 18.0077 18.0057C17.5161 18.4974 16.7189 18.4974 16.2272 18.0057L14.0007 15.7792L11.7739 18.0059C11.2823 18.4976 10.4851 18.4976 9.99343 18.0059C9.50176 17.5143 9.50176 16.7171 9.99343 16.2254L12.2202 13.9987L9.99544 11.7739C9.50377 11.2823 9.50377 10.4851 9.99544 9.99343C10.4871 9.50176 11.2843 9.50176 11.776 9.99343L14.0007 12.2182L16.2252 9.99365C16.7169 9.50198 17.5141 9.50198 18.0057 9.99365C18.4974 10.4853 18.4974 11.2825 18.0057 11.7742L15.7812 13.9987L18.0077 16.2252Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconToastSuccessSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.6666 14C25.6666 20.4433 20.4433 25.6667 14 25.6667C7.55666 25.6667 2.33331 20.4433 2.33331 14C2.33331 7.55668 7.55666 2.33333 14 2.33333C20.4433 2.33333 25.6666 7.55668 25.6666 14ZM17.7063 10.6522L12.6606 15.6979L10.2931 13.3305C9.83747 12.8749 9.09878 12.8749 8.64317 13.3305C8.18756 13.7861 8.18756 14.5248 8.64318 14.9804L11.8356 18.1728C12.2912 18.6284 13.0299 18.6284 13.4855 18.1728L19.3562 12.3021C19.8118 11.8465 19.8118 11.1078 19.3562 10.6522C18.9006 10.1966 18.1619 10.1966 17.7063 10.6522Z"
                    fill="currentColor"
                ></path>
            </svg>
        )}
        {...props}
    />
);

export const IconClockSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.7451 3.97906L12.7141 3.01014L13.6569 3.95295L12.6879 4.92187C13.509 5.94832 14 7.25033 14 8.66699C14 11.9807 11.3137 14.667 8 14.667C4.68629 14.667 2 11.9807 2 8.66699C2 5.35329 4.68629 2.66699 8 2.66699C9.41667 2.66699 10.7187 3.15797 11.7451 3.97906ZM8 13.3337C10.5773 13.3337 12.6667 11.2443 12.6667 8.66699C12.6667 6.08967 10.5773 4.00033 8 4.00033C5.42267 4.00033 3.33333 6.08967 3.33333 8.66699C3.33333 11.2443 5.42267 13.3337 8 13.3337ZM7.33333 5.33366H8.66667V9.33366H7.33333V5.33366ZM5.33333 0.666992H10.6667V2.00033H5.33333V0.666992Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconClockFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5C4.86 1.5 1.5 4.86 1.5 9ZM9.74982 8.68518V6.00018L9.75732 5.99268C9.75732 5.58018 9.41982 5.24268 9.00732 5.24268C8.59482 5.24268 8.25732 5.58018 8.25732 5.99268V8.99268C8.25732 9.19518 8.33232 9.38268 8.47482 9.52518L10.5973 11.6477C10.8898 11.9402 11.3623 11.9402 11.6548 11.6477C11.9473 11.3552 11.9473 10.8827 11.6548 10.5902L9.74982 8.68518Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconPersonSvg = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.33301 14.667C1.33301 11.7215 3.72082 9.33366 6.66634 9.33366C9.61187 9.33366 11.9997 11.7215 11.9997 14.667H10.6663C10.6663 12.4579 8.87547 10.667 6.66634 10.667C4.4572 10.667 2.66634 12.4579 2.66634 14.667H1.33301ZM6.66634 8.66699C4.45634 8.66699 2.66634 6.87699 2.66634 4.66699C2.66634 2.45699 4.45634 0.666992 6.66634 0.666992C8.87634 0.666992 10.6663 2.45699 10.6663 4.66699C10.6663 6.87699 8.87634 8.66699 6.66634 8.66699ZM6.66634 7.33366C8.13967 7.33366 9.33301 6.14033 9.33301 4.66699C9.33301 3.19366 8.13967 2.00033 6.66634 2.00033C5.19301 2.00033 3.99967 3.19366 3.99967 4.66699C3.99967 6.14033 5.19301 7.33366 6.66634 7.33366ZM12.1888 9.80219C14.0426 10.6377 15.333 12.5017 15.333 14.667H13.9997C13.9997 13.043 13.0319 11.6451 11.6415 11.0184L12.1888 9.80219ZM11.7305 2.2758C13.0626 2.82501 13.9997 4.13607 13.9997 5.66699C13.9997 7.58046 12.5358 9.15046 10.6663 9.31873V7.97673C11.7975 7.81513 12.6663 6.84299 12.6663 5.66699C12.6663 4.74656 12.1341 3.95101 11.3603 3.57123L11.7305 2.2758Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconSetting = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.78288 14.1669C2.49368 13.666 2.26239 13.1476 2.08694 12.6193C2.012 12.3936 2.1236 12.155 2.31498 12.0139C2.9325 11.5587 3.3331 10.8262 3.3331 10.0002C3.3331 9.17477 2.93298 8.44268 2.3161 7.98741C2.12504 7.84641 2.01363 7.60809 2.08813 7.38263C2.44109 6.31459 3.00979 5.31529 3.77506 4.45632C3.93307 4.27897 4.1953 4.25646 4.41294 4.35163C5.11603 4.65906 5.9509 4.63986 6.66643 4.22675C7.38197 3.81363 7.81602 3.10022 7.90132 2.33761C7.92773 2.10155 8.07834 1.8857 8.31093 1.83754C9.43748 1.60428 10.5872 1.61141 11.6886 1.83976C11.9212 1.88797 12.0718 2.10362 12.0984 2.33958C12.1842 3.10145 12.6181 3.81399 13.3331 4.22675C14.0485 4.63975 14.8831 4.65905 15.586 4.35187C15.8039 4.25666 16.0664 4.27935 16.2244 4.45708C16.5941 4.87314 16.9274 5.33267 17.2167 5.83359C17.5058 6.3345 17.7371 6.85295 17.9126 7.3812C17.9875 7.60683 17.8759 7.84551 17.6845 7.98658C17.067 8.44178 16.6664 9.17425 16.6664 10.0002C16.6664 10.8258 17.0665 11.5578 17.6834 12.0131C17.8745 12.1541 17.9859 12.3924 17.9114 12.6179C17.5585 13.6859 16.9898 14.6852 16.2245 15.5442C16.0665 15.7215 15.8042 15.7441 15.5866 15.6489C14.8835 15.3415 14.0486 15.3607 13.3331 15.7737C12.6175 16.1868 12.1835 16.9003 12.0982 17.6629C12.0718 17.899 11.9212 18.1148 11.6886 18.163C10.5621 18.3962 9.41232 18.3891 8.31087 18.1607C8.07836 18.1125 7.92768 17.8969 7.9011 17.6609C7.81528 16.899 7.38135 16.1865 6.66643 15.7737C5.95108 15.3608 5.11647 15.3414 4.4135 15.6486C4.19563 15.7438 3.93312 15.7211 3.77518 15.5434C3.40543 15.1273 3.07208 14.6678 2.78288 14.1669ZM7.49976 14.3304C8.40925 14.8555 9.06242 15.6857 9.37525 16.6383C9.7905 16.6778 10.2085 16.6784 10.6238 16.6397C10.9365 15.6865 11.5898 14.8557 12.4997 14.3304C13.4097 13.805 14.4558 13.6547 15.4377 13.8604C15.6788 13.5201 15.8873 13.1577 16.0607 12.7784C15.3922 12.0312 14.9997 11.0504 14.9997 10.0002C14.9997 8.95008 15.3922 7.96941 16.0607 7.22216C15.974 7.03383 15.8782 6.8486 15.7732 6.66692C15.6683 6.48524 15.5558 6.30965 15.4361 6.14043C14.4547 6.34571 13.4092 6.1952 12.4997 5.67012C11.5902 5.14504 10.9372 4.31481 10.6242 3.36221C10.2091 3.3227 9.791 3.32213 9.37575 3.36085C9.063 4.31401 8.40966 5.14478 7.49976 5.67012C6.58983 6.19547 5.54371 6.34586 4.5619 6.14011C4.32071 6.48042 4.11219 6.84272 3.9388 7.22206C4.60734 7.96934 4.99977 8.95008 4.99977 10.0002C4.99977 11.0504 4.60736 12.0311 3.9388 12.7783C4.02556 12.9667 4.12136 13.1519 4.22626 13.3336C4.33116 13.5152 4.44367 13.6908 4.56343 13.8601C5.54481 13.6548 6.59031 13.8053 7.49976 14.3304ZM9.99975 12.5002C8.61908 12.5002 7.49976 11.381 7.49976 10.0002C7.49976 8.61958 8.61908 7.50026 9.99975 7.50026C11.3805 7.50026 12.4997 8.61958 12.4997 10.0002C12.4997 11.381 11.3805 12.5002 9.99975 12.5002ZM9.99975 10.8336C10.46 10.8336 10.8331 10.4605 10.8331 10.0002C10.8331 9.54 10.46 9.16691 9.99975 9.16691C9.5395 9.16691 9.16641 9.54 9.16641 10.0002C9.16641 10.4605 9.5395 10.8336 9.99975 10.8336Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconGrid = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.3414 17.4997H12.9914C12.5581 17.4997 12.2914 17.4997 12.0914 17.4831C11.8581 17.4664 11.6997 17.4247 11.5581 17.3581C11.3081 17.2247 11.1164 17.0331 10.9914 16.7997C10.9164 16.6497 10.8747 16.4831 10.8581 16.2497C10.8414 16.0497 10.8414 15.7831 10.8414 15.3497V12.9997C10.8414 12.5664 10.8414 12.2997 10.8581 12.0997C10.8747 11.8664 10.9164 11.7081 10.9831 11.5664C11.1164 11.3164 11.3081 11.1247 11.5414 10.9997C11.6914 10.9247 11.8581 10.8831 12.0914 10.8664C12.2914 10.8497 12.5581 10.8497 12.9914 10.8497H15.3414C15.7747 10.8497 16.0414 10.8497 16.2414 10.8664C16.4747 10.8831 16.6331 10.9247 16.7747 10.9914C17.0247 11.1247 17.2164 11.3164 17.3414 11.5497C17.4164 11.6997 17.4581 11.8664 17.4747 12.0997C17.4914 12.2997 17.4914 12.5664 17.4914 12.9997V15.3497C17.4914 15.7831 17.4914 16.0497 17.4747 16.2497C17.4581 16.4664 17.4247 16.6247 17.3581 16.7581C17.2164 17.0331 17.0247 17.2247 16.7831 17.3497C16.6331 17.4247 16.4664 17.4664 16.2331 17.4831C16.0331 17.4997 15.7664 17.4997 15.3331 17.4997H15.3414ZM12.9914 15.8331H15.3414C15.5414 15.8331 15.6997 15.8331 15.8331 15.8331C15.8331 15.6914 15.8331 15.5414 15.8331 15.3414V12.9914C15.8331 12.7914 15.8331 12.6331 15.8331 12.4997C15.6914 12.4997 15.5414 12.4997 15.3414 12.4997H12.9914C12.7914 12.4997 12.6331 12.4997 12.4997 12.4997C12.4997 12.6414 12.4997 12.7914 12.4997 12.9914V15.3414C12.4997 15.5414 12.4997 15.6997 12.4997 15.8331C12.6414 15.8331 12.7914 15.8331 12.9914 15.8331ZM7.00806 17.4997H4.65806C4.22472 17.4997 3.95806 17.4997 3.75806 17.4831C3.52472 17.4664 3.36639 17.4247 3.22472 17.3581C2.96639 17.2247 2.78306 17.0331 2.65806 16.7914C2.59139 16.6664 2.54139 16.4997 2.52472 16.2497C2.50806 16.0414 2.50806 15.7747 2.50806 15.3414V12.9914C2.50806 12.5581 2.50806 12.2914 2.52472 12.0914C2.54972 11.8414 2.59139 11.6664 2.67472 11.5247C2.79139 11.3081 2.98306 11.1164 3.21639 10.9914C3.36639 10.9164 3.53306 10.8747 3.76639 10.8581C3.96639 10.8414 4.24139 10.8414 4.66639 10.8414H7.01639C7.44972 10.8414 7.71639 10.8414 7.91639 10.8581C8.14972 10.8747 8.30806 10.9164 8.44972 10.9831C8.70806 11.1164 8.89139 11.3081 9.01639 11.5497C9.08306 11.6747 9.13306 11.8414 9.14972 12.0914C9.16639 12.2997 9.16639 12.5664 9.16639 12.9997V15.3497C9.16639 15.7831 9.16639 16.0497 9.14972 16.2497C9.12472 16.4997 9.08306 16.6747 8.99972 16.8164C8.88306 17.0331 8.69139 17.2247 8.45806 17.3497C8.30806 17.4247 8.14139 17.4664 7.90806 17.4831C7.70806 17.4997 7.43306 17.4997 7.00806 17.4997ZM4.65806 15.8331H7.00806C7.20806 15.8331 7.36639 15.8331 7.49972 15.8331C7.49972 15.6914 7.49972 15.5414 7.49972 15.3414V12.9914C7.49972 12.7914 7.49972 12.6331 7.49972 12.4997C7.35806 12.4997 7.20806 12.4997 7.00806 12.4997H4.65806C4.45806 12.4997 4.29972 12.4997 4.16639 12.4997C4.16639 12.6414 4.16639 12.7914 4.16639 12.9914V15.3414C4.16639 15.5414 4.16639 15.6997 4.16639 15.8331C4.30806 15.8331 4.45806 15.8331 4.65806 15.8331ZM15.3414 9.16639H12.9914C12.5581 9.16639 12.2914 9.16639 12.0914 9.14972C11.8414 9.12472 11.6664 9.08306 11.5247 8.99972C11.3081 8.88306 11.1164 8.69139 10.9914 8.45806C10.9164 8.30806 10.8747 8.14139 10.8581 7.90806C10.8414 7.70806 10.8414 7.43306 10.8414 7.00806V4.65806C10.8414 4.22472 10.8414 3.95806 10.8581 3.75806C10.8747 3.52472 10.9164 3.36639 10.9831 3.22472C11.1164 2.96639 11.3081 2.78306 11.5497 2.65806C11.6747 2.59139 11.8414 2.54139 12.0914 2.52472C12.2997 2.50806 12.5664 2.50806 12.9997 2.50806H15.3497C15.7831 2.50806 16.0497 2.50806 16.2497 2.52472C16.4997 2.54972 16.6747 2.59139 16.8164 2.67472C17.0331 2.79139 17.2247 2.98306 17.3497 3.21639C17.4247 3.36639 17.4664 3.53306 17.4831 3.76639C17.4997 3.96639 17.4997 4.24139 17.4997 4.66639V7.01639C17.4997 7.44972 17.4997 7.71639 17.4831 7.91639C17.4664 8.14972 17.4247 8.30806 17.3581 8.44972C17.2247 8.70806 17.0331 8.89139 16.7914 9.01639C16.6664 9.08306 16.4997 9.13306 16.2497 9.14972C16.0414 9.16639 15.7747 9.16639 15.3414 9.16639ZM12.9914 7.49972H15.3414C15.5414 7.49972 15.6997 7.49972 15.8331 7.49972C15.8331 7.35806 15.8331 7.20806 15.8331 7.00806V4.65806C15.8331 4.45806 15.8331 4.29972 15.8331 4.16639C15.6914 4.16639 15.5414 4.16639 15.3414 4.16639H12.9914C12.7914 4.16639 12.6331 4.16639 12.4997 4.16639C12.4997 4.30806 12.4997 4.45806 12.4997 4.65806V7.00806C12.4997 7.20806 12.4997 7.36639 12.4997 7.49972C12.6414 7.49972 12.7914 7.49972 12.9914 7.49972ZM7.00806 9.16639H4.65806C4.22472 9.16639 3.95806 9.16639 3.75806 9.14972C3.50806 9.12472 3.33306 9.08306 3.19139 8.99972C2.97472 8.88306 2.78306 8.69139 2.65806 8.45806C2.59139 8.33306 2.54139 8.16639 2.52472 7.91639C2.50806 7.70806 2.50806 7.44139 2.50806 7.00806V4.65806C2.50806 4.22472 2.50806 3.95806 2.52472 3.75806C2.54972 3.50806 2.59139 3.33306 2.67472 3.19139C2.79139 2.97472 2.98306 2.78306 3.21639 2.65806C3.34139 2.59139 3.50806 2.54139 3.75806 2.52472C3.96639 2.50806 4.23306 2.50806 4.66639 2.50806H7.01639C7.44972 2.50806 7.71639 2.50806 7.91639 2.52472C8.16639 2.54972 8.34139 2.59139 8.48306 2.67472C8.69972 2.79139 8.89139 2.98306 9.01639 3.21639C9.08306 3.34139 9.13306 3.50806 9.14972 3.75806C9.16639 3.96639 9.16639 4.23306 9.16639 4.66639V7.01639C9.16639 7.44972 9.16639 7.71639 9.14972 7.91639C9.12472 8.16639 9.08306 8.34139 8.99972 8.48306C8.88306 8.69972 8.69139 8.89139 8.45806 9.01639C8.33306 9.08306 8.16639 9.13306 7.91639 9.14972C7.70806 9.16639 7.44139 9.16639 7.00806 9.16639ZM4.65806 7.49972H7.00806C7.20806 7.49972 7.36639 7.49972 7.49972 7.49972C7.49972 7.35806 7.49972 7.20806 7.49972 7.00806V4.65806C7.49972 4.45806 7.49972 4.29972 7.49972 4.16639C7.35806 4.16639 7.20806 4.16639 7.00806 4.16639H4.65806C4.45806 4.16639 4.29972 4.16639 4.16639 4.16639C4.16639 4.30806 4.16639 4.45806 4.16639 4.65806V7.00806C4.16639 7.20806 4.16639 7.36639 4.16639 7.49972C4.30806 7.49972 4.45806 7.49972 4.65806 7.49972Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconGridHollow = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.3414 17.4997H12.9914C12.5581 17.4997 12.2914 17.4997 12.0914 17.4831C11.8581 17.4664 11.6997 17.4247 11.5581 17.3581C11.3081 17.2247 11.1164 17.0331 10.9914 16.7997C10.9164 16.6497 10.8747 16.4831 10.8581 16.2497C10.8414 16.0497 10.8414 15.7831 10.8414 15.3497V12.9997C10.8414 12.5664 10.8414 12.2997 10.8581 12.0997C10.8747 11.8664 10.9164 11.7081 10.9831 11.5664C11.1164 11.3164 11.3081 11.1247 11.5414 10.9997C11.6914 10.9247 11.8581 10.8831 12.0914 10.8664C12.2914 10.8497 12.5581 10.8497 12.9914 10.8497H15.3414C15.7747 10.8497 16.0414 10.8497 16.2414 10.8664C16.4747 10.8831 16.6331 10.9247 16.7747 10.9914C17.0247 11.1247 17.2164 11.3164 17.3414 11.5497C17.4164 11.6997 17.4581 11.8664 17.4747 12.0997C17.4914 12.2997 17.4914 12.5664 17.4914 12.9997V15.3497C17.4914 15.7831 17.4914 16.0497 17.4747 16.2497C17.4581 16.4664 17.4247 16.6247 17.3581 16.7581C17.2164 17.0331 17.0247 17.2247 16.7831 17.3497C16.6331 17.4247 16.4664 17.4664 16.2331 17.4831C16.0331 17.4997 15.7664 17.4997 15.3331 17.4997H15.3414ZM12.9914 15.8331H15.3414C15.5414 15.8331 15.6997 15.8331 15.8331 15.8331C15.8331 15.6914 15.8331 15.5414 15.8331 15.3414V12.9914C15.8331 12.7914 15.8331 12.6331 15.8331 12.4997C15.6914 12.4997 15.5414 12.4997 15.3414 12.4997H12.9914C12.7914 12.4997 12.6331 12.4997 12.4997 12.4997C12.4997 12.6414 12.4997 12.7914 12.4997 12.9914V15.3414C12.4997 15.5414 12.4997 15.6997 12.4997 15.8331C12.6414 15.8331 12.7914 15.8331 12.9914 15.8331ZM7.00806 17.4997H4.65806C4.22472 17.4997 3.95806 17.4997 3.75806 17.4831C3.52472 17.4664 3.36639 17.4247 3.22472 17.3581C2.96639 17.2247 2.78306 17.0331 2.65806 16.7914C2.59139 16.6664 2.54139 16.4997 2.52472 16.2497C2.50806 16.0414 2.50806 15.7747 2.50806 15.3414V12.9914C2.50806 12.5581 2.50806 12.2914 2.52472 12.0914C2.54972 11.8414 2.59139 11.6664 2.67472 11.5247C2.79139 11.3081 2.98306 11.1164 3.21639 10.9914C3.36639 10.9164 3.53306 10.8747 3.76639 10.8581C3.96639 10.8414 4.24139 10.8414 4.66639 10.8414H7.01639C7.44972 10.8414 7.71639 10.8414 7.91639 10.8581C8.14972 10.8747 8.30806 10.9164 8.44972 10.9831C8.70806 11.1164 8.89139 11.3081 9.01639 11.5497C9.08306 11.6747 9.13306 11.8414 9.14972 12.0914C9.16639 12.2997 9.16639 12.5664 9.16639 12.9997V15.3497C9.16639 15.7831 9.16639 16.0497 9.14972 16.2497C9.12472 16.4997 9.08306 16.6747 8.99972 16.8164C8.88306 17.0331 8.69139 17.2247 8.45806 17.3497C8.30806 17.4247 8.14139 17.4664 7.90806 17.4831C7.70806 17.4997 7.43306 17.4997 7.00806 17.4997ZM4.65806 15.8331H7.00806C7.20806 15.8331 7.36639 15.8331 7.49972 15.8331C7.49972 15.6914 7.49972 15.5414 7.49972 15.3414V12.9914C7.49972 12.7914 7.49972 12.6331 7.49972 12.4997C7.35806 12.4997 7.20806 12.4997 7.00806 12.4997H4.65806C4.45806 12.4997 4.29972 12.4997 4.16639 12.4997C4.16639 12.6414 4.16639 12.7914 4.16639 12.9914V15.3414C4.16639 15.5414 4.16639 15.6997 4.16639 15.8331C4.30806 15.8331 4.45806 15.8331 4.65806 15.8331ZM15.3414 9.16639H12.9914C12.5581 9.16639 12.2914 9.16639 12.0914 9.14972C11.8414 9.12472 11.6664 9.08306 11.5247 8.99972C11.3081 8.88306 11.1164 8.69139 10.9914 8.45806C10.9164 8.30806 10.8747 8.14139 10.8581 7.90806C10.8414 7.70806 10.8414 7.43306 10.8414 7.00806V4.65806C10.8414 4.22472 10.8414 3.95806 10.8581 3.75806C10.8747 3.52472 10.9164 3.36639 10.9831 3.22472C11.1164 2.96639 11.3081 2.78306 11.5497 2.65806C11.6747 2.59139 11.8414 2.54139 12.0914 2.52472C12.2997 2.50806 12.5664 2.50806 12.9997 2.50806H15.3497C15.7831 2.50806 16.0497 2.50806 16.2497 2.52472C16.4997 2.54972 16.6747 2.59139 16.8164 2.67472C17.0331 2.79139 17.2247 2.98306 17.3497 3.21639C17.4247 3.36639 17.4664 3.53306 17.4831 3.76639C17.4997 3.96639 17.4997 4.24139 17.4997 4.66639V7.01639C17.4997 7.44972 17.4997 7.71639 17.4831 7.91639C17.4664 8.14972 17.4247 8.30806 17.3581 8.44972C17.2247 8.70806 17.0331 8.89139 16.7914 9.01639C16.6664 9.08306 16.4997 9.13306 16.2497 9.14972C16.0414 9.16639 15.7747 9.16639 15.3414 9.16639ZM12.9914 7.49972H15.3414C15.5414 7.49972 15.6997 7.49972 15.8331 7.49972C15.8331 7.35806 15.8331 7.20806 15.8331 7.00806V4.65806C15.8331 4.45806 15.8331 4.29972 15.8331 4.16639C15.6914 4.16639 15.5414 4.16639 15.3414 4.16639H12.9914C12.7914 4.16639 12.6331 4.16639 12.4997 4.16639C12.4997 4.30806 12.4997 4.45806 12.4997 4.65806V7.00806C12.4997 7.20806 12.4997 7.36639 12.4997 7.49972C12.6414 7.49972 12.7914 7.49972 12.9914 7.49972ZM7.00806 9.16639H4.65806C4.22472 9.16639 3.95806 9.16639 3.75806 9.14972C3.50806 9.12472 3.33306 9.08306 3.19139 8.99972C2.97472 8.88306 2.78306 8.69139 2.65806 8.45806C2.59139 8.33306 2.54139 8.16639 2.52472 7.91639C2.50806 7.70806 2.50806 7.44139 2.50806 7.00806V4.65806C2.50806 4.22472 2.50806 3.95806 2.52472 3.75806C2.54972 3.50806 2.59139 3.33306 2.67472 3.19139C2.79139 2.97472 2.98306 2.78306 3.21639 2.65806C3.34139 2.59139 3.50806 2.54139 3.75806 2.52472C3.96639 2.50806 4.23306 2.50806 4.66639 2.50806H7.01639C7.44972 2.50806 7.71639 2.50806 7.91639 2.52472C8.16639 2.54972 8.34139 2.59139 8.48306 2.67472C8.69972 2.79139 8.89139 2.98306 9.01639 3.21639C9.08306 3.34139 9.13306 3.50806 9.14972 3.75806C9.16639 3.96639 9.16639 4.23306 9.16639 4.66639V7.01639C9.16639 7.44972 9.16639 7.71639 9.14972 7.91639C9.12472 8.16639 9.08306 8.34139 8.99972 8.48306C8.88306 8.69972 8.69139 8.89139 8.45806 9.01639C8.33306 9.08306 8.16639 9.13306 7.91639 9.14972C7.70806 9.16639 7.44139 9.16639 7.00806 9.16639ZM4.65806 7.49972H7.00806C7.20806 7.49972 7.36639 7.49972 7.49972 7.49972C7.49972 7.35806 7.49972 7.20806 7.49972 7.00806V4.65806C7.49972 4.45806 7.49972 4.29972 7.49972 4.16639C7.35806 4.16639 7.20806 4.16639 7.00806 4.16639H4.65806C4.45806 4.16639 4.29972 4.16639 4.16639 4.16639C4.16639 4.30806 4.16639 4.45806 4.16639 4.65806V7.00806C4.16639 7.20806 4.16639 7.36639 4.16639 7.49972C4.30806 7.49972 4.45806 7.49972 4.65806 7.49972Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconArrowUpRight = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.1769 6.25873H6.24191C5.82941 6.25873 5.49191 5.92123 5.49191 5.50873C5.49191 5.09623 5.82941 4.75873 6.24191 4.75873H12.9919C13.4044 4.75873 13.7419 5.09623 13.7419 5.50873V12.2587C13.7419 12.6712 13.4044 13.0087 12.9919 13.0087C12.5794 13.0087 12.2419 12.6712 12.2419 12.2587V7.31623L6.31691 13.2412C6.02441 13.5337 5.55191 13.5337 5.25941 13.2412C4.96691 12.9487 4.96691 12.4762 5.25941 12.1837L11.1769 6.25873Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconArrowDownRight = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.6769 11.8547H5.74191C5.32941 11.8547 4.99191 12.1922 4.99191 12.6047C4.99191 13.0172 5.32941 13.3547 5.74191 13.3547H12.4919C12.9044 13.3547 13.2419 13.0172 13.2419 12.6047V5.8547C13.2419 5.4422 12.9044 5.1047 12.4919 5.1047C12.0794 5.1047 11.7419 5.4422 11.7419 5.8547V10.7972L5.81691 4.8647C5.52441 4.5722 5.05191 4.5722 4.75941 4.8647C4.46691 5.1572 4.46691 5.6297 4.75941 5.9222L10.6844 11.8472L10.6769 11.8547Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconArrowUpWild = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.3335 10.236C13.0735 10.496 12.6535 10.496 12.3935 10.236L8.00018 5.84271L3.61352 10.236C3.35352 10.496 2.93352 10.496 2.67352 10.236C2.41352 9.97604 2.41352 9.55604 2.67352 9.29604L7.53352 4.42937C7.79352 4.16938 8.21352 4.16938 8.47352 4.42937L13.3335 9.28938C13.5935 9.54938 13.5935 9.96937 13.3335 10.2294V10.236Z"
                    fill="currentColor"
                />
            </svg>
        )}
    />
);

export const IconArrowDownWild = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.66668 6.43621C2.92668 6.17621 3.34668 6.17621 3.60668 6.43621L8.00001 10.8295L12.3933 6.43621C12.6533 6.17621 13.0733 6.17621 13.3333 6.43621C13.5933 6.69621 13.5933 7.11621 13.3333 7.37621L8.47335 12.2362C8.21335 12.4962 7.79335 12.4962 7.53335 12.2362L2.66668 7.38288C2.40668 7.12288 2.40668 6.70288 2.66668 6.44288V6.43621Z"
                    fill="currentColor"
                />
            </svg>
        )}
    />
);

export const IconMangeSetting = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5.83342 3.33333C5.37318 3.33333 5.00008 3.70642 5.00008 4.16666V4.99999H2.50008C2.04175 4.99999 1.66675 5.37499 1.66675 5.83333C1.66675 6.29166 2.04175 6.66666 2.50008 6.66666H5.00008V7.49999C5.00008 7.96023 5.37318 8.33333 5.83342 8.33333C6.29365 8.33333 6.66675 7.96023 6.66675 7.49999V4.16666C6.66675 3.70642 6.29365 3.33333 5.83342 3.33333Z"
                    fill="currentColor"
                />
                <path
                    d="M17.5001 6.66666H8.33342V4.99999H17.5001C17.9584 4.99999 18.3334 5.37499 18.3334 5.83333C18.3334 6.29166 17.9584 6.66666 17.5001 6.66666Z"
                    fill="currentColor"
                />
                <path
                    d="M14.1667 11.6667C14.627 11.6667 15.0001 12.0398 15.0001 12.5V13.3333H17.5001C17.9584 13.3333 18.3334 13.7083 18.3334 14.1667C18.3334 14.625 17.9584 15 17.5001 15H15.0001V15.8333C15.0001 16.2936 14.627 16.6667 14.1667 16.6667C13.7065 16.6667 13.3334 16.2936 13.3334 15.8333V12.5C13.3334 12.0398 13.7065 11.6667 14.1667 11.6667Z"
                    fill="currentColor"
                />
                <path
                    d="M2.50008 15H11.6667V13.3333H2.50008C2.04175 13.3333 1.66675 13.7083 1.66675 14.1667C1.66675 14.625 2.04175 15 2.50008 15Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconQr = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.47781 1.60129H5.54876C6.11765 1.60127 6.59747 1.60126 6.98903 1.63628C7.3994 1.67299 7.791 1.75309 8.15671 1.96145C8.57136 2.1977 8.91703 2.53827 9.1579 2.94998C9.3711 3.31439 9.45305 3.70503 9.49049 4.11271C9.52611 4.50055 9.5261 4.9753 9.52608 5.53569V5.60807C9.5261 6.16846 9.52611 6.64321 9.49049 7.03106C9.45305 7.43874 9.3711 7.82937 9.1579 8.19379C8.91703 8.6055 8.57136 8.94607 8.15671 9.18232C7.791 9.39068 7.3994 9.47078 6.98903 9.50748C6.59747 9.5425 6.11766 9.54249 5.54877 9.54248H5.4778C4.90892 9.54249 4.4291 9.5425 4.03755 9.50748C3.62717 9.47078 3.23557 9.39068 2.86987 9.18232C2.45521 8.94607 2.10955 8.6055 1.86868 8.19379C1.65547 7.82937 1.57352 7.43874 1.53608 7.03106C1.50046 6.64321 1.50047 6.16845 1.50049 5.60804V5.53572C1.50047 4.97532 1.50046 4.50056 1.53608 4.11271C1.57352 3.70503 1.65547 3.31439 1.86868 2.94998C2.10955 2.53827 2.45521 2.1977 2.86987 1.96145C3.23557 1.75309 3.62717 1.67299 4.03755 1.63628C4.4291 1.60126 4.90892 1.60127 5.47781 1.60129ZM4.18144 3.24516C3.88114 3.27202 3.75005 3.31905 3.6695 3.36494C3.49947 3.46182 3.3596 3.60039 3.2629 3.76567C3.21846 3.84163 3.17158 3.9668 3.14462 4.26044C3.11659 4.5656 3.1158 4.9656 3.1158 5.57188C3.1158 6.17817 3.11659 6.57817 3.14462 6.88332C3.17158 7.17697 3.21846 7.30213 3.2629 7.37809C3.3596 7.54338 3.49947 7.68195 3.6695 7.77882C3.75005 7.82472 3.88114 7.87174 4.18144 7.8986C4.49245 7.92642 4.8995 7.92717 5.51329 7.92717C6.12707 7.92717 6.53412 7.92642 6.84513 7.8986C7.14543 7.87174 7.27652 7.82472 7.35707 7.77882C7.5271 7.68195 7.66698 7.54338 7.76368 7.37809C7.80812 7.30213 7.85499 7.17697 7.88196 6.88332C7.90998 6.57817 7.91078 6.17817 7.91078 5.57188C7.91078 4.9656 7.90998 4.5656 7.88196 4.26044C7.85499 3.9668 7.80812 3.84163 7.76368 3.76567C7.66698 3.60039 7.5271 3.46182 7.35707 3.36494C7.27652 3.31905 7.14543 3.27202 6.84513 3.24516C6.53412 3.21735 6.12707 3.21659 5.51329 3.21659C4.8995 3.21659 4.49245 3.21735 4.18144 3.24516ZM14.4522 1.60129H14.5232C15.0921 1.60127 15.5719 1.60126 15.9634 1.63628C16.3738 1.67299 16.7654 1.75309 17.1311 1.96145C17.5458 2.1977 17.8914 2.53827 18.1323 2.94998C18.3455 3.31439 18.4275 3.70503 18.4649 4.11271C18.5005 4.50056 18.5005 4.97532 18.5005 5.53573V5.60803C18.5005 6.16844 18.5005 6.6432 18.4649 7.03106C18.4275 7.43874 18.3455 7.82937 18.1323 8.19379C17.8914 8.6055 17.5458 8.94607 17.1311 9.18232C16.7654 9.39068 16.3738 9.47078 15.9634 9.50748C15.5719 9.5425 15.0921 9.54249 14.5232 9.54248H14.4522C13.8833 9.54249 13.4035 9.5425 13.0119 9.50748C12.6016 9.47078 12.21 9.39068 11.8443 9.18232C11.4296 8.94607 11.084 8.6055 10.8431 8.19379C10.6299 7.82937 10.5479 7.43874 10.5105 7.03106C10.4749 6.6432 10.4749 6.16844 10.4749 5.60803V5.53573C10.4749 4.97532 10.4749 4.50056 10.5105 4.11271C10.5479 3.70503 10.6299 3.31439 10.8431 2.94998C11.084 2.53827 11.4296 2.1977 11.8443 1.96145C12.21 1.75309 12.6016 1.67299 13.0119 1.63628C13.4035 1.60126 13.8833 1.60127 14.4522 1.60129ZM13.1558 3.24516C12.8555 3.27202 12.7245 3.31905 12.6439 3.36494C12.4739 3.46182 12.334 3.60039 12.2373 3.76567C12.1929 3.84163 12.146 3.9668 12.119 4.26044C12.091 4.5656 12.0902 4.9656 12.0902 5.57188C12.0902 6.17817 12.091 6.57817 12.119 6.88332C12.146 7.17697 12.1929 7.30213 12.2373 7.37809C12.334 7.54338 12.4739 7.68195 12.6439 7.77882C12.7245 7.82472 12.8555 7.87174 13.1558 7.8986C13.4669 7.92642 13.8739 7.92717 14.4877 7.92717C15.1015 7.92717 15.5085 7.92642 15.8195 7.8986C16.1198 7.87174 16.2509 7.82472 16.3315 7.77882C16.5015 7.68195 16.6414 7.54338 16.7381 7.37809C16.7825 7.30213 16.8294 7.17697 16.8564 6.88332C16.8844 6.57817 16.8852 6.17817 16.8852 5.57188C16.8852 4.9656 16.8844 4.5656 16.8564 4.26044C16.8294 3.9668 16.7825 3.84163 16.7381 3.76567C16.6414 3.60039 16.5015 3.46182 16.3315 3.36494C16.2509 3.31905 16.1198 3.27202 15.8195 3.24516C15.5085 3.21735 15.1015 3.21659 14.4877 3.21659C13.8739 3.21659 13.4669 3.21735 13.1558 3.24516ZM5.4778 10.4575H5.54877C6.11766 10.4575 6.59747 10.4575 6.98903 10.4925C7.3994 10.5292 7.791 10.6093 8.15671 10.8177C8.57136 11.0539 8.91703 11.3945 9.1579 11.8062C9.3711 12.1706 9.45305 12.5613 9.49049 12.9689C9.52611 13.3568 9.5261 13.8315 9.52608 14.3919V14.4643C9.5261 15.0247 9.52611 15.4994 9.49049 15.8873C9.45305 16.295 9.3711 16.6856 9.1579 17.05C8.91703 17.4617 8.57136 17.8023 8.15671 18.0386C7.791 18.2469 7.3994 18.327 6.98903 18.3637C6.59747 18.3987 6.11764 18.3987 5.54873 18.3987H5.47784C4.90894 18.3987 4.42911 18.3987 4.03754 18.3637C3.62717 18.327 3.23557 18.2469 2.86987 18.0386C2.45521 17.8023 2.10955 17.4617 1.86868 17.05C1.65547 16.6856 1.57352 16.295 1.53608 15.8873C1.50046 15.4994 1.50047 15.0247 1.50049 14.4643V14.392C1.50047 13.8316 1.50046 13.3568 1.53608 12.9689C1.57352 12.5613 1.65547 12.1706 1.86868 11.8062C2.10955 11.3945 2.45521 11.0539 2.86987 10.8177C3.23557 10.6093 3.62717 10.5292 4.03755 10.4925C4.4291 10.4575 4.90892 10.4575 5.4778 10.4575ZM4.18144 12.1014C3.88114 12.1283 3.75005 12.1753 3.6695 12.2212C3.49947 12.3181 3.3596 12.4566 3.2629 12.6219C3.21846 12.6979 3.17158 12.823 3.14462 13.1167C3.11659 13.4218 3.1158 13.8218 3.1158 14.4281C3.1158 15.0344 3.11659 15.4344 3.14462 15.7396C3.17158 16.0332 3.21846 16.1584 3.2629 16.2343C3.3596 16.3996 3.49947 16.5382 3.6695 16.6351C3.75005 16.681 3.88114 16.728 4.18144 16.7548C4.49245 16.7826 4.8995 16.7834 5.51329 16.7834C6.12707 16.7834 6.53412 16.7826 6.84513 16.7548C7.14543 16.728 7.27652 16.681 7.35707 16.6351C7.5271 16.5382 7.66698 16.3996 7.76368 16.2343C7.80812 16.1584 7.85499 16.0332 7.88196 15.7396C7.90998 15.4344 7.91078 15.0344 7.91078 14.4281C7.91078 13.8218 7.90998 13.4218 7.88196 13.1167C7.85499 12.823 7.80812 12.6979 7.76368 12.6219C7.66698 12.4566 7.5271 12.3181 7.35707 12.2212C7.27652 12.1753 7.14543 12.1283 6.84513 12.1014C6.53412 12.0736 6.12707 12.0728 5.51329 12.0728C4.8995 12.0728 4.49245 12.0736 4.18144 12.1014Z"
                    fill="currentColor"
                />
                <path
                    d="M12.4618 11.5127C12.9716 11.5127 13.3849 11.9205 13.3849 12.4236C13.3849 12.9267 12.9716 13.3346 12.4618 13.3346C11.952 13.3346 11.5387 12.9267 11.5387 12.4236C11.5387 11.9205 11.952 11.5127 12.4618 11.5127Z"
                    fill="currentColor"
                />
                <path
                    d="M14.6156 13.6382C15.1254 13.6382 15.5387 14.0461 15.5387 14.5491C15.5387 15.0522 15.1254 15.4601 14.6156 15.4601C14.1058 15.4601 13.6926 15.0522 13.6926 14.5491C13.6926 14.0461 14.1058 13.6382 14.6156 13.6382Z"
                    fill="currentColor"
                />
                <path
                    d="M16.7695 11.5127C17.2793 11.5127 17.6926 11.9205 17.6926 12.4236C17.6926 12.9267 17.2793 13.3346 16.7695 13.3346C16.2597 13.3346 15.8464 12.9267 15.8464 12.4236C15.8464 11.9205 16.2597 11.5127 16.7695 11.5127Z"
                    fill="currentColor"
                />
                <path
                    d="M12.4618 15.7637C12.9716 15.7637 13.3849 16.1716 13.3849 16.6747C13.3849 17.1778 12.9716 17.5856 12.4618 17.5856C11.952 17.5856 11.5387 17.1778 11.5387 16.6747C11.5387 16.1716 11.952 15.7637 12.4618 15.7637Z"
                    fill="currentColor"
                />
                <path
                    d="M16.7695 15.7637C17.2793 15.7637 17.6926 16.1716 17.6926 16.6747C17.6926 17.1778 17.2793 17.5856 16.7695 17.5856C16.2597 17.5856 15.8464 17.1778 15.8464 16.6747C15.8464 16.1716 16.2597 15.7637 16.7695 15.7637Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconEye = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.1139 9.75253C19.0872 9.69218 18.4402 8.25684 17.0018 6.81843C15.0852 4.90183 12.6644 3.88892 9.99998 3.88892C7.33553 3.88892 4.91477 4.90183 2.99817 6.81843C1.55976 8.25684 0.909695 9.69448 0.886014 9.75253C0.851267 9.83069 0.833313 9.91526 0.833313 10.0008C0.833313 10.0863 0.851267 10.1709 0.886014 10.2491C0.91275 10.3094 1.55976 11.744 2.99817 13.1824C4.91477 15.0982 7.33553 16.1111 9.99998 16.1111C12.6644 16.1111 15.0852 15.0982 17.0018 13.1824C18.4402 11.744 19.0872 10.3094 19.1139 10.2491C19.1487 10.1709 19.1666 10.0863 19.1666 10.0008C19.1666 9.91526 19.1487 9.83069 19.1139 9.75253ZM9.99998 13.0556C9.39565 13.0556 8.80489 12.8764 8.3024 12.5406C7.79992 12.2049 7.40828 11.7277 7.17701 11.1693C6.94574 10.611 6.88523 9.99664 7.00313 9.40392C7.12103 8.8112 7.41205 8.26675 7.83937 7.83943C8.2667 7.4121 8.81115 7.12108 9.40387 7.00319C9.99659 6.88529 10.611 6.9458 11.1693 7.17706C11.7276 7.40833 12.2048 7.79997 12.5406 8.30245C12.8763 8.80494 13.0555 9.3957 13.0555 10C13.0555 10.8104 12.7336 11.5876 12.1606 12.1606C11.5876 12.7337 10.8104 13.0556 9.99998 13.0556Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconEyeClose = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.34115 2.86669C4.28748 2.8062 4.22234 2.75696 4.1495 2.72182C4.07666 2.68669 3.99758 2.66636 3.91683 2.66202C3.83607 2.65767 3.75526 2.6694 3.67908 2.69651C3.60289 2.72363 3.53284 2.7656 3.47299 2.81999C3.41315 2.87438 3.36469 2.9401 3.33043 3.01336C3.29617 3.08661 3.27679 3.16594 3.27342 3.24673C3.27004 3.32753 3.28274 3.4082 3.31077 3.48405C3.33879 3.55991 3.3816 3.62945 3.4367 3.68864L4.90642 5.30579C2.13198 7.0085 0.938783 9.63323 0.886075 9.75239C0.851328 9.83055 0.833374 9.91513 0.833374 10.0007C0.833374 10.0862 0.851328 10.1708 0.886075 10.2489C0.912811 10.3093 1.55983 11.7439 2.99823 13.1823C4.91483 15.0981 7.33559 16.111 10 16.111C11.3694 16.1188 12.7249 15.8369 13.9776 15.2837L15.6582 17.1331C15.7118 17.1936 15.777 17.2428 15.8498 17.278C15.9227 17.3131 16.0017 17.3334 16.0825 17.3378C16.1632 17.3421 16.2441 17.3304 16.3202 17.3033C16.3964 17.2762 16.4665 17.2342 16.5263 17.1798C16.5862 17.1254 16.6346 17.0597 16.6689 16.9864C16.7031 16.9132 16.7225 16.8339 16.7259 16.7531C16.7293 16.6723 16.7166 16.5916 16.6885 16.5157C16.6605 16.4399 16.6177 16.3703 16.5626 16.3111L4.34115 2.86669ZM11.1398 12.1625C10.6604 12.4146 10.1109 12.5005 9.57748 12.4065C9.04407 12.3125 8.55698 12.044 8.19269 11.6432C7.82841 11.2424 7.60756 10.7319 7.56484 10.1919C7.52211 9.65201 7.65993 9.11316 7.95664 8.66003L11.1398 12.1625ZM19.114 10.2489C19.0819 10.3207 18.3081 12.0341 16.5657 13.5948C16.4456 13.7025 16.2878 13.7584 16.1266 13.7503C15.9655 13.7421 15.8141 13.6706 15.7055 13.5512L7.96809 5.03996C7.89407 4.95874 7.84333 4.85905 7.8212 4.75141C7.79906 4.64377 7.80637 4.53216 7.84233 4.42832C7.8783 4.32448 7.94161 4.23226 8.02558 4.16137C8.10955 4.09048 8.21108 4.04355 8.31948 4.02551C8.87496 3.9338 9.43705 3.88806 10 3.88878C12.6645 3.88878 15.0853 4.9017 17.0019 6.8183C18.4403 8.2567 19.0873 9.69205 19.114 9.75239C19.1488 9.83055 19.1667 9.91513 19.1667 10.0007C19.1667 10.0862 19.1488 10.1708 19.114 10.2489Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSearch = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C12.8859 18 14.5977 17.2542 15.8564 16.0414C15.8827 16.0072 15.9115 15.9742 15.9429 15.9429C15.9742 15.9115 16.0072 15.8827 16.0414 15.8564C17.2542 14.5977 18 12.8859 18 11C18 7.13401 14.866 4 11 4ZM18.0319 16.6177C19.2635 15.078 20 13.125 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C13.125 20 15.078 19.2635 16.6177 18.0319L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L18.0319 16.6177Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconPassword = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.59417 9.63792L15.2108 3.02124L16.9787 4.78901L15.8002 5.96751L17.5679 7.73528L14.6216 10.6816L12.8538 8.91383L10.3619 11.4057C11.1818 12.9765 10.9322 14.9602 9.61292 16.2795C7.98576 17.9067 5.34758 17.9067 3.72039 16.2795C2.0932 14.6523 2.0932 12.0141 3.72039 10.3869C5.03963 9.06767 7.02341 8.818 8.59417 9.63792ZM7.84518 14.5117C8.49609 13.8608 8.49609 12.8056 7.84518 12.1547C7.1943 11.5038 6.13904 11.5038 5.48816 12.1547C4.83729 12.8056 4.83729 13.8608 5.48816 14.5117C6.13904 15.1626 7.1943 15.1626 7.84518 14.5117Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconSecretPhrase = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.99992 18.3333V11.6666C6.31802 11.6666 3.33325 14.6513 3.33325 18.3333H9.99992ZM4.99992 5.83325C4.99992 8.59575 7.23742 10.8333 9.99992 10.8333C12.7624 10.8333 14.9999 8.59575 14.9999 5.83325C14.9999 3.07075 12.7624 0.833252 9.99992 0.833252C7.23742 0.833252 4.99992 3.07075 4.99992 5.83325ZM15.8956 14.9285L17.1034 13.7207L18.2162 14.8335L19.3291 13.7207L18.2162 12.6079L18.7726 12.0514L17.6598 10.9386L14.7827 13.8157C13.9052 13.3965 12.8224 13.5503 12.0956 14.2771C11.1737 15.199 11.1737 16.6937 12.0956 17.6156C13.0175 18.5375 14.5122 18.5375 15.4341 17.6156C16.1609 16.8888 16.3147 15.806 15.8956 14.9285ZM14.3213 15.39C14.6286 15.6973 14.6286 16.1955 14.3213 16.5028C14.014 16.8101 13.5158 16.8101 13.2084 16.5028C12.9011 16.1955 12.9011 15.6973 13.2084 15.39C13.5157 15.0827 14.014 15.0826 14.3213 15.39Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconPrivateKey = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4679_28687)">
                    <path
                        d="M13.4722 3.86364H15.5556C15.7397 3.86364 15.9164 3.93547 16.0466 4.06334C16.1768 4.1912 16.25 4.36463 16.25 4.54545V16.8182C16.25 16.999 16.1768 17.1724 16.0466 17.3003C15.9164 17.4282 15.7397 17.5 15.5556 17.5H4.44444C4.26027 17.5 4.08363 17.4282 3.9534 17.3003C3.82316 17.1724 3.75 16.999 3.75 16.8182V4.54545C3.75 4.36463 3.82316 4.1912 3.9534 4.06334C4.08363 3.93547 4.26027 3.86364 4.44444 3.86364H6.52778V2.5H7.91667V3.86364H12.0833V2.5H13.4722V3.86364ZM6.52778 7.95455V9.31818H13.4722V7.95455H6.52778ZM6.52778 10.6818V12.0455H13.4722V10.6818H6.52778Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_4679_28687">
                        <rect width="20" height="20" fill="currentColor" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);

export const IconArrowDownWithoutTail = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.66698 6.43597C2.92698 6.17597 3.34698 6.17597 3.60698 6.43597L8.00032 10.8293L12.3937 6.43597C12.6537 6.17597 13.0737 6.17597 13.3337 6.43597C13.5937 6.69597 13.5937 7.11597 13.3337 7.37597L8.47365 12.236C8.21365 12.496 7.79365 12.496 7.53365 12.236L2.66698 7.38263C2.40698 7.12263 2.40698 6.70263 2.66698 6.44263V6.43597Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconDownFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.50578 10.0232L3.57925 6.61214C3.39836 6.4054 3.54695 6.07593 3.82475 6.07593H10.1753C10.453 6.07593 10.6016 6.39894 10.4207 6.61214L7.49422 10.0297C7.2358 10.3333 6.77066 10.3333 6.51224 10.0297L6.50578 10.0232Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconTxContract = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM17.6569 12L14.1213 15.5355L12.7071 14.1213L14.8284 12L12.7071 9.87868L14.1213 8.46447L17.6569 12ZM6.34315 12L9.87868 8.46447L11.2929 9.87868L9.17157 12L11.2929 14.1213L9.87868 15.5355L6.34315 12Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const SwapActionBuy = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="111"
                height="28"
                viewBox="0 0 111 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0 6.4C0 4.15979 0 3.03968 0.435974 2.18404C0.819467 1.43139 1.43139 0.819467 2.18404 0.435974C3.03968 0 4.15979 0 6.4 0H99.302C100.656 0 101.334 0 101.939 0.197847C102.475 0.372893 102.967 0.659161 103.385 1.03789C103.856 1.46595 104.192 2.05428 104.862 3.23095L109.194 10.831C109.852 11.9862 110.181 12.5638 110.31 13.1771C110.424 13.7198 110.424 14.2802 110.31 14.8229C110.181 15.4362 109.852 16.0138 109.194 17.169L104.862 24.7691C104.192 25.9457 103.856 26.5341 103.385 26.9621C102.967 27.3408 102.475 27.6271 101.939 27.8022C101.334 28 100.656 28 99.302 28H6.40001C4.15979 28 3.03968 28 2.18404 27.564C1.43139 27.1805 0.819467 26.5686 0.435974 25.816C0 24.9603 0 23.8402 0 21.6V6.4Z"
                    fill="#00C057"
                />
            </svg>
        )}
        {...props}
    />
);

export const SwapActionSell = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="111"
                height="28"
                viewBox="0 0 111 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M111 6.4C111 4.15979 111 3.03968 110.564 2.18404C110.181 1.43139 109.569 0.819467 108.816 0.435974C107.96 0 106.84 0 104.6 0H11.698C10.3437 0 9.66649 0 9.06103 0.197847C8.52534 0.372893 8.03269 0.659161 7.61535 1.03789C7.14366 1.46595 6.80835 2.05428 6.13771 3.23095L1.80617 10.831C1.14775 11.9862 0.818545 12.5638 0.689618 13.1771C0.575532 13.7198 0.575532 14.2802 0.689618 14.8229C0.818545 15.4362 1.14775 16.0138 1.80617 17.169L6.13772 24.7691C6.80835 25.9457 7.14366 26.5341 7.61535 26.9621C8.03269 27.3408 8.52534 27.6271 9.06103 27.8022C9.66649 28 10.3437 28 11.698 28H104.6C106.84 28 107.96 28 108.816 27.564C109.569 27.1805 110.181 26.5686 110.564 25.816C111 24.9603 111 23.8402 111 21.6V6.4Z"
                    fill="#FE3B30"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconContract = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 1.5L15.75 5.25V15.7561C15.75 16.167 15.4163 16.5 15.0049 16.5H2.99505C2.58357 16.5 2.25 16.1585 2.25 15.7561V2.24385C2.25 1.83304 2.58371 1.5 2.99505 1.5H12ZM13.2427 9L10.591 6.34835L9.53032 7.40901L11.1213 9L9.53032 10.591L10.591 11.6516L13.2427 9ZM4.75736 9L7.40901 11.6516L8.46968 10.591L6.87868 9L8.46968 7.40901L7.40901 6.34835L4.75736 9Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconRank = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5.25 7.81579H2.25V13.5H5.25V7.81579Z"
                    fill="currentColor"
                />
                <path
                    d="M15.75 5.28947H12.75V13.5H15.75V5.28947Z"
                    fill="currentColor"
                />
                <path d="M10.5 1.5H7.5V13.5H10.5V1.5Z" fill="currentColor" />
                <path d="M15.75 15H2.25V16.5H15.75V15Z" fill="currentColor" />
            </svg>
        )}
        {...props}
    />
);

export const IconCap = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 1.5C2.61929 1.5 1.5 2.61929 1.5 4V14C1.5 15.3807 2.61929 16.5 4 16.5H14C15.3807 16.5 16.5 15.3807 16.5 14V4C16.5 2.61929 15.3807 1.5 14 1.5H4ZM12.6919 8.25382C12.9846 7.96076 12.9844 7.48588 12.6913 7.19316C12.3982 6.90043 11.9234 6.9007 11.6306 7.19376L9.92756 8.89876L8.54416 7.51731C8.25264 7.2262 7.78089 7.22473 7.48756 7.51402L5.27744 9.69374C4.98253 9.98459 4.97924 10.4595 5.27009 10.7544C5.56095 11.0493 6.03581 11.0526 6.33073 10.7617L8.01092 9.10464L9.39828 10.49C9.69135 10.7827 10.1662 10.7824 10.4589 10.4894L12.6919 8.25382Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconExchange = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.6396 9.10984L16.2343 5.51517C16.3807 5.36873 16.3807 5.13129 16.2343 4.98484L12.6396 1.39017C12.4034 1.15394 11.9995 1.32125 11.9995 1.65534L11.9995 3.75001H9.54491C8.00102 3.75001 6.74946 5.00158 6.74945 6.54546C6.74945 6.65843 6.84103 6.75001 6.954 6.75001L11.9995 6.75001V8.84468C11.9995 9.17877 12.4034 9.34608 12.6396 9.10984Z"
                    fill="currentColor"
                />
                <path
                    d="M5.35929 16.6099L1.76462 13.0152C1.61817 12.8688 1.61817 12.6313 1.76462 12.4849L5.35929 8.8902C5.59553 8.65396 5.99945 8.82128 5.99946 9.15537V11.25L11.058 11.25C11.1637 11.25 11.2495 11.3358 11.2495 11.4415C11.2495 12.9926 9.99204 14.25 8.44094 14.25H5.99946V16.3447C5.99945 16.6788 5.59553 16.8461 5.35929 16.6099Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconExchange2 = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.49144 9.56632C6.78394 9.85882 6.78394 10.3313 6.49144 10.6238L5.11895 11.9963L14.2464 11.9963C14.6589 11.9963 14.9964 12.3338 14.9964 12.7463C14.9964 13.1588 14.6589 13.4963 14.2464 13.4963L5.11895 13.4963L6.49145 14.8688C6.78395 15.1613 6.78395 15.6338 6.49145 15.9263C6.19895 16.2188 5.72645 16.2188 5.43395 15.9263L2.77895 13.2788C2.48645 12.9863 2.48645 12.5138 2.77895 12.2213L5.43394 9.56632C5.72644 9.27382 6.19894 9.27382 6.49144 9.56632ZM12.5664 2.06631L15.2214 4.72131C15.5139 5.01382 15.5139 5.48632 15.2214 5.77882L12.5664 8.43382C12.2739 8.72632 11.8014 8.72632 11.5089 8.43382C11.2164 8.14132 11.2164 7.66882 11.5089 7.37632L12.8814 6.00382L3.75394 6.00382C3.34144 6.00382 3.00394 5.66632 3.00394 5.25382C3.00394 4.84132 3.34144 4.50382 3.75394 4.50382L12.8814 4.50382L11.5089 3.13131C11.2164 2.83882 11.2164 2.36631 11.5089 2.07381C11.8014 1.78132 12.2739 1.78132 12.5664 2.07381L12.5664 2.06631Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconLiquidity = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.7067 1.97876L6.95674 10.9788L5.14617 7.87493H1.5V10.1249H3.85383L7.29326 16.0211L11.0433 7.02109L12.8538 10.1249H16.5V7.87493H14.1462L10.7067 1.97876Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconEdit = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.06817 14.4711C4.94315 14.5961 4.77358 14.6663 4.59677 14.6663H2.00016C1.63197 14.6663 1.3335 14.3679 1.3335 13.9997V11.4031C1.3335 11.2263 1.40373 11.0567 1.52876 10.9317L10.8832 1.57718C11.2088 1.25162 11.7347 1.25162 12.0603 1.57718L14.4227 3.93957C14.7482 4.26513 14.7482 4.79104 14.4227 5.11659L5.06817 14.4711ZM13.1256 4.52808L4.32063 13.333H2.66683V11.6792L11.4718 2.87428L13.1256 4.52808Z"
                    fill="#0F0F13"
                />
                <path
                    d="M13.9979 13.333H7.60914L6.27581 14.6663H13.9979C14.3661 14.6663 14.6646 14.3679 14.6646 13.9997C14.6646 13.6315 14.3661 13.333 13.9979 13.333Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconCirclePlus = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4998 16.667C14.1817 16.667 17.1665 13.6822 17.1665 10.0003C17.1665 6.31843 14.1817 3.33366 10.4998 3.33366C6.81794 3.33366 3.83317 6.31843 3.83317 10.0003C3.83317 13.6822 6.81794 16.667 10.4998 16.667ZM10.4998 18.3337C15.1022 18.3337 18.8332 14.6027 18.8332 10.0003C18.8332 5.39795 15.1022 1.66699 10.4998 1.66699C5.89746 1.66699 2.1665 5.39795 2.1665 10.0003C2.1665 14.6027 5.89746 18.3337 10.4998 18.3337Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 13.75C10.9602 13.75 11.3333 13.3769 11.3333 12.9167L11.3333 10.8333H13.4167C13.8769 10.8333 14.25 10.4602 14.25 10C14.25 9.53976 13.8769 9.16667 13.4167 9.16667H11.3333L11.3333 7.08333C11.3333 6.6231 10.9602 6.25 10.5 6.25C10.0398 6.25 9.66667 6.6231 9.66667 7.08333V9.16667L7.58333 9.16667C7.1231 9.16667 6.75 9.53976 6.75 10C6.75 10.4602 7.1231 10.8333 7.58333 10.8333H9.66667L9.66667 12.9167C9.66667 13.3769 10.0398 13.75 10.5 13.75Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconError = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="57"
                height="56"
                viewBox="0 0 57 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="0.5" width="56" height="56" rx="28" fill="#FE3B30" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.2626 19.7626C20.946 19.0791 22.054 19.0791 22.7374 19.7626L28.5 25.5251L34.2626 19.7626C34.946 19.0791 36.054 19.0791 36.7374 19.7626C37.4209 20.446 37.4209 21.554 36.7374 22.2374L30.9749 28L36.7374 33.7626C37.4209 34.446 37.4209 35.554 36.7374 36.2374C36.054 36.9209 34.946 36.9209 34.2626 36.2374L28.5 30.4749L22.7374 36.2374C22.054 36.9209 20.946 36.9209 20.2626 36.2374C19.5791 35.554 19.5791 34.446 20.2626 33.7626L26.0251 28L20.2626 22.2374C19.5791 21.554 19.5791 20.446 20.2626 19.7626Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconSucc = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="57"
                height="56"
                viewBox="0 0 57 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="0.5" width="56" height="56" rx="28" fill="#31D158" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M39.3197 19.8195C40.0601 20.5789 40.0601 21.81 39.3197 22.5694L26.0489 36.1805C25.3085 36.9398 24.1081 36.9398 23.3678 36.1805L17.6803 30.3472C16.9399 29.5878 16.9399 28.3566 17.6803 27.5973C18.4206 26.8379 19.621 26.8379 20.3614 27.5973L24.7083 32.0557L36.6386 19.8195C37.379 19.0602 38.5794 19.0602 39.3197 19.8195Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconDeveloper = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.1667 15.4166L16.302 12.4999L15.1562 13.6666L16.8749 15.4166L15.1562 17.1666L16.302 18.3333L19.1667 15.4166ZM9.99999 15.4166L12.8646 18.3333L14.0104 17.1666L12.2916 15.4166L14.0104 13.6666L12.8646 12.4999L9.99999 15.4166Z"
                    fill="currentColor"
                />
                <path
                    d="M3.33333 18.3333H9.16666V11.7182C5.87807 12.1282 3.33333 14.9336 3.33333 18.3333Z"
                    fill="currentColor"
                />
                <path
                    d="M4.99999 5.83325C4.99999 8.59575 7.23749 10.8333 9.99999 10.8333C12.7625 10.8333 15 8.59575 15 5.83325C15 3.07075 12.7625 0.833252 9.99999 0.833252C7.23749 0.833252 4.99999 3.07075 4.99999 5.83325Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconChainAll = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.1984 13.0607H6.52934C5.50229 13.0607 4.6665 12.2249 4.6665 11.1979V6.52886C4.6665 5.5018 5.50229 4.66602 6.52934 4.66602H11.1984C12.2254 4.66602 13.0612 5.5018 13.0612 6.52886V11.1979C13.0608 12.2249 12.2254 13.0607 11.1984 13.0607Z"
                    fill="currentColor"
                />
                <path
                    d="M21.4703 13.0607H16.8013C15.7743 13.0607 14.9385 12.2249 14.9385 11.1979V6.52886C14.9385 5.5018 15.7743 4.66602 16.8013 4.66602H21.4703C22.4974 4.66602 23.3332 5.5018 23.3332 6.52886V11.1979C23.3328 12.2249 22.4974 13.0607 21.4703 13.0607Z"
                    fill="currentColor"
                />
                <path
                    d="M11.1984 23.3322H6.52934C5.50229 23.3322 4.6665 22.4964 4.6665 21.4693V16.8003C4.6665 15.7733 5.50229 14.9375 6.52934 14.9375H11.1984C12.2254 14.9375 13.0612 15.7733 13.0612 16.8003V21.4693C13.0608 22.4964 12.2254 23.3322 11.1984 23.3322Z"
                    fill="currentColor"
                />
                <path
                    d="M21.4703 23.3322H16.8013C15.7743 23.3322 14.9385 22.4964 14.9385 21.4693V16.8003C14.9385 15.7733 15.7743 14.9375 16.8013 14.9375H21.4703C22.4973 14.9375 23.3331 15.7733 23.3331 16.8003V21.4693C23.3331 22.4964 22.4973 23.3322 21.4703 23.3322Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconWarnFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 57 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="0.5"
                    width="56"
                    height="56"
                    rx="28"
                    fill="currentColor"
                />
                <path
                    d="M28.5017 31.1537C29.6657 31.1537 30.6093 30.21 30.6093 29.046L30.6093 19.6076C30.6093 18.4436 29.6657 17.5 28.5017 17.5C27.3377 17.5 26.3941 18.4436 26.3941 19.6076L26.3941 29.046C26.3941 30.21 27.3377 31.1537 28.5017 31.1537Z"
                    fill="white"
                />
                <path
                    d="M25.9709 35.9709C25.9709 34.5741 27.1032 33.4417 28.5 33.4417C29.8968 33.4417 31.0292 34.5741 31.0292 35.9709C31.0292 37.3677 29.8968 38.5 28.5 38.5C27.1032 38.5 25.9709 37.3677 25.9709 35.9709Z"
                    fill="white"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconProtocol = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.4722 3.86364H15.5556C15.7397 3.86364 15.9164 3.93547 16.0466 4.06334C16.1768 4.1912 16.25 4.36463 16.25 4.54545V16.8182C16.25 16.999 16.1768 17.1724 16.0466 17.3003C15.9164 17.4282 15.7397 17.5 15.5556 17.5H4.44444C4.26027 17.5 4.08363 17.4282 3.9534 17.3003C3.82316 17.1724 3.75 16.999 3.75 16.8182V4.54545C3.75 4.36463 3.82316 4.1912 3.9534 4.06334C4.08363 3.93547 4.26027 3.86364 4.44444 3.86364H6.52778V2.5H7.91667V3.86364H12.0833V2.5H13.4722V3.86364ZM6.52778 7.95455V9.31818H13.4722V7.95455H6.52778ZM6.52778 10.6818V12.0455H13.4722V10.6818H6.52778Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconMinus = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337ZM13.1252 8.95898C13.7005 8.95898 14.1668 9.42535 14.1668 10.0007C14.1668 10.5759 13.7005 11.0423 13.1252 11.0423L6.87516 11.0423C6.29987 11.0423 5.8335 10.5759 5.8335 10.0007C5.8335 9.42535 6.29987 8.95898 6.87516 8.95898H13.1252Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconVector = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="4"
                height="18"
                viewBox="0 0 4 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2 0C1.175 0 0.5 0.675 0.5 1.5C0.5 2.325 1.175 3 2 3C2.825 3 3.5 2.325 3.5 1.5C3.5 0.675 2.825 0 2 0ZM2 15C1.175 15 0.5 15.675 0.5 16.5C0.5 17.325 1.175 18 2 18C2.825 18 3.5 17.325 3.5 16.5C3.5 15.675 2.825 15 2 15ZM2 7.5C1.175 7.5 0.5 8.175 0.5 9C0.5 9.825 1.175 10.5 2 10.5C2.825 10.5 3.5 9.825 3.5 9C3.5 8.175 2.825 7.5 2 7.5Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconFourFlower = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5.62504 2.08398C7.58105 2.08398 9.16671 3.66964 9.16671 5.62565V9.16732H5.62504C3.66903 9.16732 2.08337 7.58166 2.08337 5.62565C2.08337 3.66964 3.66903 2.08398 5.62504 2.08398ZM5.62504 10.834H9.16671V14.3757C9.16671 16.3317 7.58105 17.9173 5.62504 17.9173C3.66903 17.9173 2.08337 16.3317 2.08337 14.3757C2.08337 12.4197 3.66903 10.834 5.62504 10.834ZM14.375 2.08398C16.331 2.08398 17.9167 3.66964 17.9167 5.62565C17.9167 7.58166 16.331 9.16732 14.375 9.16732H10.8334V5.62565C10.8334 3.66964 12.419 2.08398 14.375 2.08398ZM10.8334 10.834H14.375C16.331 10.834 17.9167 12.4197 17.9167 14.3757C17.9167 16.3317 16.331 17.9173 14.375 17.9173C12.419 17.9173 10.8334 16.3317 10.8334 14.3757V10.834Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconDelete = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20 7V21C20 21.55 19.55 22 19 22H5C4.45 22 4 21.55 4 21V7H3C2.45 7 2 6.55 2 6C2 5.45 2.45 5 3 5H21C21.55 5 22 5.45 22 6C22 6.55 21.55 7 21 7H20ZM6 7V20H18V7H6ZM8 2H16C16.55 2 17 2.45 17 3C17 3.55 16.55 4 16 4H8C7.45 4 7 3.55 7 3C7 2.45 7.45 2 8 2Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
export const IconNft = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9 12C10.1046 12 11 11.1046 11 10C11 8.89543 10.1046 8 9 8C7.89543 8 7 8.89543 7 10C7 11.1046 7.89543 12 9 12ZM21.5 6.5L12 1L2.5 6.5V17.5L12 23L21.5 17.5V6.5ZM12 3.311L19.5 7.65311V14.5338L14.9379 11.7966L6.96669 17.775L4.5 16.3469V7.65311L12 3.311ZM12 20.689L8.84788 18.8641L15.0621 14.2034L19.0595 16.6019L12 20.689Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconShieldSafe = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 1L4.28307 2.82598C3.82553 2.92766 3.5 3.33347 3.5 3.80217V13.7889C3.5 15.795 4.50261 17.6684 6.1718 18.7812L12.5 23L18.8282 18.7812C20.4974 17.6684 21.5 15.795 21.5 13.7889V3.80217C21.5 3.33347 21.1745 2.92766 20.7169 2.82598L12.5 1ZM5.5 13.7889V4.60434L12.5 3.04879L19.5 4.60434V13.7889C19.5 15.1263 18.8316 16.3752 17.7188 17.1171L12.5 20.5963L7.2812 17.1171C6.1684 16.3752 5.5 15.1263 5.5 13.7889ZM11.4425 12.4077L15.4272 8.42298C15.787 8.06318 16.3703 8.06318 16.7301 8.42298C17.09 8.78279 17.09 9.36615 16.7301 9.72595L12.094 14.3621C11.7341 14.7219 11.1508 14.7219 10.791 14.3621L8.26986 11.841C7.91005 11.4812 7.91005 10.8979 8.26985 10.5381C8.62965 10.1783 9.21301 10.1783 9.57282 10.5381L11.4425 12.4077Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconTokenRisk = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.0447 7.38609L10.0184 7.38705C6.88983 7.38705 4.35367 9.91025 4.35367 13.0227C4.35367 16.1352 6.88983 18.6584 10.0184 18.6584H10.6566H11.255H13.7084C14.3363 18.6584 14.8453 18.1519 14.8453 17.5273C14.8453 16.9026 14.3363 16.3962 13.7084 16.3962H11.2949H11.255H10.4571C8.38725 16.3962 6.70734 14.8953 6.70734 13.0329C6.70734 11.1705 8.38725 9.64518 10.4571 9.64518L13.0028 9.65305L13.0029 9.64865H16.1611C16.1611 10.9643 14.9936 12.0307 13.5535 12.0307C13.5052 12.0307 13.4599 12.0294 13.4167 12.027V12.0305H10.0782C9.51643 12.0305 9.06101 12.4836 9.06101 13.0425C9.06101 13.6015 9.51643 14.0547 10.0782 14.0547H11.0556H11.255H11.2949H13.7084C15.6362 14.0547 17.1989 15.6094 17.1989 17.5273C17.1989 19.4452 15.6362 21 13.7084 21H11.255H10.0184C5.58996 21 2 17.4284 2 13.0227C2 8.61703 5.58996 5.04545 10.0184 5.04545H12.6513H15.0447H17.3585C17.3585 6.32537 16.3262 7.3648 15.0447 7.38609ZM23.7628 6.22632H22.3618V7.6825C22.3618 7.80764 22.2557 7.90909 22.1247 7.90909H20.8596C20.7286 7.90909 20.6224 7.80764 20.6224 7.6825V6.22632H19.2561C19.125 6.22632 19.0189 6.12487 19.0189 5.99973V4.90462C19.0189 4.77948 19.125 4.67814 19.2561 4.67814H20.6224V3.22659C20.6224 3.10145 20.7286 3 20.8596 3H22.1247C22.2557 3 22.3618 3.10145 22.3618 3.22659V4.67814H23.7628C23.8938 4.67814 24 4.77948 24 4.90462V5.99973C24 6.12487 23.8938 6.22632 23.7628 6.22632Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconUnknow = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1L3.78307 2.82598C3.32553 2.92766 3 3.33347 3 3.80217V13.7889C3 15.795 4.00261 17.6684 5.6718 18.7812L12 23L18.3282 18.7812C19.9974 17.6684 21 15.795 21 13.7889V3.80217C21 3.33347 20.6745 2.92766 20.2169 2.82598L12 1ZM5 13.7889V4.60434L12 3.04879L19 4.60434V13.7889C19 15.1263 18.3316 16.3752 17.2188 17.1171L12 20.5963L6.7812 17.1171C5.6684 16.3752 5 15.1263 5 13.7889ZM12.2409 7.99604C11.7988 7.92021 11.3441 8.00329 10.9574 8.23056C10.5707 8.45784 10.2769 8.81464 10.128 9.23777C9.95398 9.73254 9.41179 9.99254 8.91702 9.81849C8.42225 9.64444 8.16225 9.10225 8.3363 8.60748C8.634 7.76121 9.22159 7.04761 9.99501 6.59306C10.7684 6.13852 11.6778 5.97236 12.562 6.12402C13.4462 6.27568 14.2481 6.73538 14.8259 7.42168C15.4035 8.10785 15.7197 8.97626 15.7185 9.87317C15.718 11.3265 14.6405 12.2863 13.8711 12.7993C13.4574 13.0751 13.0504 13.2779 12.7506 13.4111C12.5994 13.4783 12.472 13.5293 12.3803 13.5643C12.3343 13.5818 12.297 13.5954 12.2699 13.605L12.2201 13.6223C11.7225 13.7881 11.1847 13.5192 11.0188 13.0217C10.8531 12.5244 11.1215 11.987 11.6184 11.8207L11.6336 11.8154C11.6482 11.8102 11.6722 11.8015 11.7041 11.7894C11.7681 11.765 11.8634 11.7269 11.9792 11.6754C12.2136 11.5713 12.5189 11.4179 12.8175 11.2189C13.4724 10.7823 13.8191 10.3178 13.8191 9.8723L13.8191 9.87089C13.8198 9.42234 13.6617 8.98803 13.3728 8.64487C13.0839 8.30172 12.683 8.07187 12.2409 7.99604ZM12.2699 13.605L12.2369 13.6166L12.2264 13.6202L12.2227 13.6214L12.2213 13.6219L12.2699 13.605ZM13.136 15.9297C13.136 16.5591 12.6258 17.0693 11.9964 17.0693C11.367 17.0693 10.8567 16.5591 10.8567 15.9297C10.8567 15.3003 11.367 14.7901 11.9964 14.7901C12.6258 14.7901 13.136 15.3003 13.136 15.9297Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconRisk = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1L3.78307 2.82598C3.32553 2.92766 3 3.33347 3 3.80217V13.7889C3 15.795 4.00261 17.6684 5.6718 18.7812L12 23L18.3282 18.7812C19.9974 17.6684 21 15.795 21 13.7889V3.80217C21 3.33347 20.6745 2.92766 20.2169 2.82598L12 1ZM5 13.7889V4.60434L12 3.04879L19 4.60434V13.7889C19 15.1263 18.3316 16.3752 17.2188 17.1171L12 20.5963L6.7812 17.1171C5.6684 16.3752 5 15.1263 5 13.7889ZM13 7.13379C13 6.5815 12.5523 6.13379 12 6.13379C11.4477 6.13379 11 6.5815 11 7.13379V11.1338C11 11.6861 11.4477 12.1338 12 12.1338C12.5523 12.1338 13 11.6861 13 11.1338V7.13379ZM11.9948 13.4067C11.3354 13.4067 10.8008 13.944 10.8008 14.6067C10.8008 15.2695 11.3354 15.8067 11.9948 15.8067H12.0068C12.6662 15.8067 13.2008 15.2695 13.2008 14.6067C13.2008 13.944 12.6662 13.4067 12.0068 13.4067H11.9948Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconSortUp = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="calc(1em*0.66666667)"
                viewBox="0 0 6 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.62204 0.436436C2.82142 0.206205 3.17858 0.206205 3.37796 0.436436L4.88159 2.17267C5.16203 2.4965 4.932 3 4.50363 3L1.49637 3C1.068 3 0.837972 2.4965 1.11841 2.17267L2.62204 0.436436Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconSortDown = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="calc(1em*0.66666667)"
                viewBox="0 0 6 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.62204 3.56356C2.82142 3.7938 3.17858 3.7938 3.37796 3.56356L4.88159 1.82733C5.16203 1.5035 4.932 1 4.50363 1L1.49637 1C1.068 1 0.837972 1.5035 1.11841 1.82733L2.62204 3.56356Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconP2p = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5ZM7 3C4.79086 3 3 4.79086 3 7V9H5V7C5 5.89543 5.89543 5 7 5H10V3H7ZM17 21C19.2091 21 21 19.2091 21 17V15H19V17C19 18.1046 18.1046 19 17 19H14V21H17ZM7 16C8.65685 16 10 14.6569 10 13C10 11.3431 8.65685 10 7 10C5.34315 10 4 11.3431 4 13C4 14.6569 5.34315 16 7 16ZM17 9C14.7909 9 13 10.7909 13 13H21C21 10.7909 19.2091 9 17 9ZM3 21C3 18.7909 4.79086 17 7 17C9.20914 17 11 18.7909 11 21H3Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconUXUYWallet = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 1024 1024"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="rounded overflow-hidden"
            >
                <g clipPath="url(#clip0_5631_70350)">
                    <path d="M1024 0H0V1024H1024V0Z" fill="#FF7400" />
                    <path
                        d="M300.07 366.24H724.362C763.19 366.24 794.667 397.717 794.667 436.545V711.768C794.667 750.597 763.19 782.073 724.362 782.073H300.071C261.243 782.073 229.766 750.597 229.766 711.768V436.543C229.766 397.716 261.242 366.24 300.07 366.24Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="9.53288"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M642.971 277.609L309.509 317.171C282.274 320.402 261.056 342.322 258.713 369.648L258.327 374.155V390.936H696.029L674.376 299.56C671.004 285.327 657.495 275.886 642.971 277.609ZM706.657 291.91C699.398 261.278 670.324 240.956 639.063 244.665L305.601 284.227C262.738 289.312 229.346 323.81 225.66 366.815L225.152 372.736V446.365L270.266 422.59H737.623L706.657 291.91Z"
                        fill="white"
                    />
                    <path
                        d="M523.092 721.354H583.263C596.067 721.354 602.979 706.339 594.652 696.612L502.274 588.696C501.5 587.792 501.503 586.457 502.282 585.557L625.727 442.74C634.123 433.028 627.223 417.944 614.385 417.944H554.314C549.955 417.944 545.812 419.841 542.964 423.14L409.769 577.463C404.927 583.073 404.911 591.38 409.73 597.009L511.704 716.112C514.552 719.439 518.713 721.354 523.092 721.354Z"
                        fill="#FF7400"
                        stroke="white"
                        strokeWidth="12.585"
                    />
                    <path
                        d="M322.338 721.356H382.462C386.829 721.356 390.98 719.451 393.828 716.14L496.397 596.895C501.232 591.274 501.232 582.963 496.398 577.342L393.828 458.084C390.98 454.772 386.829 452.868 382.461 452.868H322.337C309.517 452.868 302.611 467.916 310.971 477.636L403.782 585.548C404.558 586.451 404.558 587.785 403.782 588.688L310.972 696.587C302.612 706.307 309.517 721.356 322.338 721.356Z"
                        fill="#FF7400"
                        stroke="white"
                        strokeWidth="12.585"
                    />
                    <path
                        d="M731.627 487C686.835 487 650.523 523.311 650.523 568.103C650.523 612.895 686.835 649.207 731.627 649.207H808.002C835.217 649.207 857.279 627.145 857.279 599.93V536.277C857.279 509.062 835.217 487 808.002 487H731.627Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M808.002 518.279H731.627C704.11 518.279 681.802 540.586 681.802 568.103C681.802 595.62 704.11 617.928 731.627 617.928H808.002C817.942 617.928 826 609.87 826 599.93V536.277C826 526.337 817.942 518.279 808.002 518.279ZM731.627 487C686.835 487 650.523 523.311 650.523 568.103C650.523 612.895 686.835 649.207 731.627 649.207H808.002C835.217 649.207 857.279 627.145 857.279 599.93V536.277C857.279 509.062 835.217 487 808.002 487H731.627Z"
                        fill="#FF7400"
                    />
                    <path
                        d="M735.125 594.809C749.432 594.809 761.03 583.211 761.03 568.905C761.03 554.598 749.432 543 735.125 543C720.819 543 709.221 554.598 709.221 568.905C709.221 583.211 720.819 594.809 735.125 594.809Z"
                        fill="#FF7400"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_5631_70350">
                        <rect width="1024" height="1024" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);

export const IconModalClose = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_3892_23135)">
                    <path
                        opacity="0.3"
                        d="M14 28C21.6589 28 28 21.6451 28 14C28 6.34117 21.6451 0 13.9863 0C6.34117 0 0 6.34117 0 14C0 21.6451 6.35489 28 14 28Z"
                        fill="#A2ACB0"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.29289 9.29289C9.68342 8.90237 10.3166 8.90237 10.7071 9.29289L14 12.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L15.4142 14L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L14 15.4142L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L12.5858 14L9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289Z"
                        fill="#707579"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_3892_23135">
                        <rect width="28" height="28" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);

export const IconCheckOk = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.274 4.98816C21.9087 5.63903 21.9087 6.6943 21.274 7.34518L9.89905 19.0118C9.26445 19.6627 8.23555 19.6627 7.60095 19.0118L2.72595 14.0118C2.09135 13.361 2.09135 12.3057 2.72595 11.6548C3.36055 11.0039 4.38945 11.0039 5.02405 11.6548L8.75 15.4763L18.976 4.98816C19.6106 4.33728 20.6394 4.33728 21.274 4.98816Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconCircleLoadingOrange = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M14 2C15.5759 2 17.1363 2.31039 18.5922 2.91345C20.0481 3.5165 21.371 4.40042 22.4853 5.51472C23.5996 6.62902 24.4835 7.95189 25.0866 9.4078C25.6896 10.8637 26 12.4241 26 14C26 15.5759 25.6896 17.1363 25.0866 18.5922C24.4835 20.0481 23.5996 21.371 22.4853 22.4853C21.371 23.5996 20.0481 24.4835 18.5922 25.0866C17.1363 25.6896 15.5759 26 14 26C12.4241 26 10.8637 25.6896 9.40779 25.0866C7.95189 24.4835 6.62902 23.5996 5.51472 22.4853C4.40041 21.371 3.5165 20.0481 2.91344 18.5922C2.31039 17.1363 2 15.5759 2 14C2 12.4241 2.31039 10.8637 2.91345 9.40779C3.51651 7.95189 4.40042 6.62902 5.51472 5.51471C6.62903 4.40041 7.9519 3.5165 9.40781 2.91344C10.8637 2.31039 12.4241 2 14 2L14 2Z"
                    stroke="#FF7400"
                    stroke-opacity="0.1"
                    stroke-width="3"
                    stroke-linecap="round"
                />
                <path
                    d="M14 2C16.0859 2 18.1357 2.54371 19.9474 3.5775C21.7591 4.61129 23.27 6.09946 24.3311 7.89524C25.3923 9.69102 25.967 11.7324 25.9986 13.818C26.0303 15.9036 25.5177 17.9615 24.5115 19.7886C23.5053 21.6158 22.0402 23.1491 20.2607 24.2373C18.4813 25.3256 16.4488 25.9312 14.3639 25.9945C12.279 26.0577 10.2136 25.5764 8.37143 24.5981C6.52925 23.6197 4.9739 22.178 3.85878 20.4153"
                    stroke="#FF7400"
                    stroke-width="3"
                    stroke-linecap="round"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconRefresh = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.615 14.1569C13.7828 14.4591 13.7179 14.8407 13.4395 15.0455C12.1965 15.9598 10.6614 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 10.6021 15.9976 12.0869 15.1419 13.3055L12.58 9.79474C12.3389 9.46434 12.5748 9 12.9839 9H15C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C10.2723 15 11.452 14.604 12.4228 13.9286C12.8158 13.6552 13.3825 13.7384 13.615 14.1569Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconInviteEarn = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.5037 5.25H1.50366V3C1.50366 2.58579 1.83945 2.25 2.25366 2.25H15.7537C16.1679 2.25 16.5037 2.58579 16.5037 3V5.25ZM16.5037 6.75V15C16.5037 15.4142 16.1679 15.75 15.7537 15.75H2.25366C1.83945 15.75 1.50366 15.4142 1.50366 15V6.75H16.5037ZM8.25368 10.5V8.625L4.87866 12H12.7537V10.5H8.25368Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconMarketFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.5 3H21.5C22.0523 3 22.5 3.44772 22.5 4V20C22.5 20.5523 22.0523 21 21.5 21H3.5C2.94772 21 2.5 20.5523 2.5 20V4C2.5 3.44772 2.94772 3 3.5 3ZM7.5 13V17H9.5V13H7.5ZM11.5 7V17H13.5V7H11.5ZM15.5 10V17H17.5V10H15.5Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconHomeFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.911 2.55715L3.42789 8.60928C2.84102 9.08393 2.5 9.79832 2.5 10.5531V19.5005C2.5 20.8812 3.61929 22.0005 5 22.0005H20C21.3807 22.0005 22.5 20.8812 22.5 19.5005V10.5561C22.5 9.79961 22.1574 9.08379 21.5683 8.60921L14.0515 2.55408C13.1345 1.81546 11.8265 1.81674 10.911 2.55715ZM13.5 14.0005C13.5 13.4482 13.0523 13.0005 12.5 13.0005C11.9477 13.0005 11.5 13.4482 11.5 14.0005V18.0005C11.5 18.5528 11.9477 19.0005 12.5 19.0005C13.0523 19.0005 13.5 18.5528 13.5 18.0005V14.0005Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconTradeFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M21.5 9C21.5 11.7039 19.849 14.0223 17.5 15.0018V15C17.5 10.3056 13.6944 6.5 9.00001 6.5H8.99817C9.97773 4.15105 12.2961 2.5 15 2.5C18.5899 2.5 21.5 5.41015 21.5 9ZM7 3C4.79086 3 3 4.79086 3 7V8.5H5V7C5 5.89543 5.89543 5 7 5H8.5V3H7ZM19 15.5V17C19 18.1046 18.1046 19 17 19H15.5V21H17C19.2091 21 21 19.2091 21 17V15.5H19ZM9 21.5C12.5899 21.5 15.5 18.5899 15.5 15C15.5 11.4101 12.5899 8.5 9 8.5C5.41015 8.5 2.5 11.4101 2.5 15C2.5 18.5899 5.41015 21.5 9 21.5ZM9 12.5L11.5 15L9 17.5L6.5 15L9 12.5Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconRewardsFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M22.5049 7H2.50488V4C2.50488 3.44772 2.9526 3 3.50488 3H21.5049C22.0572 3 22.5049 3.44772 22.5049 4V7ZM22.5049 9V20C22.5049 20.5523 22.0572 21 21.5049 21H3.50488C2.9526 21 2.50488 20.5523 2.50488 20V9H22.5049ZM11.5049 14V11.5L7.00488 16H17.5049V14H11.5049Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconTradeTXSSwap = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_8849_122510)">
                    <path
                        d="M0.800049 1.79981C0.800049 1.24752 1.24776 0.799805 1.80005 0.799805H6.20005C6.75233 0.799805 7.20005 1.24752 7.20005 1.7998V6.1998C7.20005 6.75209 6.75233 7.1998 6.20005 7.1998H1.80005C1.24776 7.1998 0.800049 6.75209 0.800049 6.1998V1.79981Z"
                        fill="var(--color_text_buy)"
                    />
                    <path
                        d="M8.80005 1.7998C8.80005 1.24752 9.24776 0.799805 9.80005 0.799805H14.2C14.7523 0.799805 15.2 1.24752 15.2 1.7998V3.4798C15.2 4.03209 14.7523 4.4798 14.2 4.4798H9.80005C9.24776 4.4798 8.80005 4.03209 8.80005 3.4798V1.7998Z"
                        fill="var(--color_text_3)"
                    />
                    <path
                        d="M8.80005 7.15996C8.80005 6.60768 9.24776 6.15996 9.80005 6.15996H14.2C14.7523 6.15996 15.2 6.60768 15.2 7.15996V8.83996C15.2 9.39224 14.7523 9.83996 14.2 9.83996H9.80005C9.24776 9.83996 8.80005 9.39224 8.80005 8.83996V7.15996Z"
                        fill="var(--color_text_3)"
                    />
                    <path
                        d="M8.80005 12.5197C8.80005 11.9674 9.24776 11.5197 9.80005 11.5197H14.2C14.7523 11.5197 15.2 11.9674 15.2 12.5197V14.1997C15.2 14.752 14.7523 15.1997 14.2 15.1997H9.80005C9.24776 15.1997 8.80005 14.752 8.80005 14.1997V12.5197Z"
                        fill="var(--color_text_3)"
                    />
                    <path
                        d="M0.800049 9.79981C0.800049 9.24752 1.24776 8.7998 1.80005 8.7998H6.20005C6.75233 8.7998 7.20005 9.24752 7.20005 9.7998V14.1998C7.20005 14.7521 6.75233 15.1998 6.20005 15.1998H1.80005C1.24776 15.1998 0.800049 14.7521 0.800049 14.1998V9.79981Z"
                        fill="var(--color_text_sell)"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_8849_122510">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);

export const IconTradeTXSBuy = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_8849_122520)">
                    <path
                        d="M0.800049 1.7998C0.800049 1.24752 1.24776 0.799805 1.80005 0.799805H6.20005C6.75233 0.799805 7.20005 1.24752 7.20005 1.7998V14.1997C7.20005 14.752 6.75233 15.1997 6.20005 15.1997H1.80005C1.24776 15.1997 0.800049 14.752 0.800049 14.1997V1.7998Z"
                        fill="var(--color_text_buy)"
                    />
                    <path
                        d="M8.80005 1.7998C8.80005 1.24752 9.24776 0.799805 9.80005 0.799805H14.2C14.7523 0.799805 15.2 1.24752 15.2 1.7998V3.4798C15.2 4.03209 14.7523 4.4798 14.2 4.4798H9.80005C9.24776 4.4798 8.80005 4.03209 8.80005 3.4798V1.7998Z"
                        fill="var(--color_text_3)"
                    />
                    <path
                        d="M8.80005 7.15996C8.80005 6.60768 9.24776 6.15996 9.80005 6.15996H14.2C14.7523 6.15996 15.2 6.60768 15.2 7.15996V8.83996C15.2 9.39224 14.7523 9.83996 14.2 9.83996H9.80005C9.24776 9.83996 8.80005 9.39224 8.80005 8.83996V7.15996Z"
                        fill="var(--color_text_3)"
                    />
                    <path
                        d="M8.80005 12.5197C8.80005 11.9674 9.24776 11.5197 9.80005 11.5197H14.2C14.7523 11.5197 15.2 11.9674 15.2 12.5197V14.1997C15.2 14.752 14.7523 15.1997 14.2 15.1997H9.80005C9.24776 15.1997 8.80005 14.752 8.80005 14.1997V12.5197Z"
                        fill="var(--color_text_3)"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_8849_122520">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);

export const IconTradeTXSSell = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_9006_108908)">
                    <path
                        d="M8.80005 1.7998C8.80005 1.24752 9.24776 0.799805 9.80005 0.799805H14.2C14.7523 0.799805 15.2 1.24752 15.2 1.7998V3.4798C15.2 4.03209 14.7523 4.4798 14.2 4.4798H9.80005C9.24776 4.4798 8.80005 4.03209 8.80005 3.4798V1.7998Z"
                        fill="var(--color_text_3)"
                    />
                    <path
                        d="M8.80005 7.15996C8.80005 6.60768 9.24776 6.15996 9.80005 6.15996H14.2C14.7523 6.15996 15.2 6.60768 15.2 7.15996V8.83996C15.2 9.39224 14.7523 9.83996 14.2 9.83996H9.80005C9.24776 9.83996 8.80005 9.39224 8.80005 8.83996V7.15996Z"
                        fill="var(--color_text_3)"
                    />
                    <path
                        d="M8.80005 12.5197C8.80005 11.9674 9.24776 11.5197 9.80005 11.5197H14.2C14.7523 11.5197 15.2 11.9674 15.2 12.5197V14.1997C15.2 14.752 14.7523 15.1997 14.2 15.1997H9.80005C9.24776 15.1997 8.80005 14.752 8.80005 14.1997V12.5197Z"
                        fill="var(--color_text_3)"
                    />
                    <path
                        d="M0.800049 1.79981C0.800049 1.24752 1.24776 0.799805 1.80005 0.799805H6.20005C6.75233 0.799805 7.20005 1.24752 7.20005 1.7998V14.1998C7.20005 14.7521 6.75233 15.1998 6.20005 15.1998H1.80005C1.24776 15.1998 0.800049 14.7521 0.800049 14.1998V1.79981Z"
                        fill="var(--color_text_sell)"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_9006_108908">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        )}
        {...props}
    />
);

export const IconStarOutline = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.99985 15.7551L5.06786 18.5158C4.69556 18.7242 4.25008 18.4005 4.33323 17.982L5.43475 12.4383L1.28512 8.60089C0.971865 8.31121 1.14202 7.78752 1.56572 7.73728L7.17846 7.0718L9.54582 1.93941C9.72452 1.55198 10.2752 1.55198 10.4539 1.93941L12.8212 7.0718L18.4339 7.73728C18.8576 7.78752 19.0278 8.31121 18.7145 8.60089L14.5649 12.4383L15.6664 17.982C15.7496 18.4005 15.3041 18.7242 14.9318 18.5158L9.99985 15.7551ZM9.99985 13.8451L13.5388 15.826L12.7483 11.8482L15.7259 9.09458L11.6985 8.61703L9.99985 4.93426L8.30113 8.61703L4.27369 9.09458L7.25127 11.8482L6.46087 15.826L9.99985 13.8451Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconMineFill = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM6.02332 15.4163C7.49083 17.6069 9.69511 19 12.1597 19C14.6243 19 16.8286 17.6069 18.2961 15.4163C16.6885 13.9172 14.5312 13 12.1597 13C9.78821 13 7.63095 13.9172 6.02332 15.4163ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconStarFilled = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M5.06786 18.5158L9.99985 15.7551L14.9318 18.5158C15.3041 18.7242 15.7496 18.4005 15.6664 17.982L14.5649 12.4383L18.7145 8.60089C19.0278 8.31121 18.8576 7.78752 18.4339 7.73728L12.8212 7.0718L10.4539 1.93941C10.2752 1.55198 9.72452 1.55198 9.54582 1.93941L7.17846 7.0718L1.56572 7.73728C1.14202 7.78752 0.971865 8.31121 1.28512 8.60089L5.43475 12.4383L4.33323 17.982C4.25008 18.4005 4.69556 18.7242 5.06786 18.5158Z"
                    fill="#FFC400"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconFavoriteFilled = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.56646 5.5437C10.3189 3.50237 10.6951 2.4817 11.2423 2.18971C11.7164 1.93676 12.2835 1.93676 12.7576 2.18971C13.3048 2.4817 13.681 3.50237 14.4334 5.5437L14.7961 6.52753C15.0135 7.1176 15.1223 7.41263 15.3098 7.63393C15.4754 7.82951 15.6843 7.98292 15.9195 8.08176C16.1857 8.1936 16.4969 8.20698 17.1192 8.23372L18.157 8.27831C20.3101 8.37084 21.3866 8.4171 21.8305 8.85298C22.215 9.23059 22.3902 9.77576 22.2987 10.3097C22.1931 10.926 21.349 11.6031 19.6609 12.9572L18.8473 13.6099C18.3594 14.0013 18.1154 14.197 17.9651 14.4456C17.8323 14.6653 17.7525 14.9136 17.7322 15.1702C17.7092 15.4607 17.7928 15.764 17.96 16.3705L18.2387 17.3819C18.817 19.4805 19.1061 20.5297 18.8332 21.0911C18.5967 21.5774 18.1379 21.9144 17.6073 21.9914C16.9948 22.0803 16.0969 21.4781 14.3012 20.2737L13.4358 19.6932C12.9167 19.345 12.6572 19.171 12.3768 19.1033C12.1291 19.0435 11.8708 19.0435 11.6231 19.1033C11.3427 19.171 11.0832 19.345 10.5641 19.6932L9.69869 20.2737C7.90298 21.4781 7.00513 22.0803 6.39261 21.9914C5.86197 21.9144 5.40319 21.5774 5.16673 21.0911C4.89378 20.5297 5.18293 19.4805 5.76122 17.3819L6.03994 16.3705C6.2071 15.764 6.29068 15.4607 6.2677 15.1702C6.24738 14.9136 6.16759 14.6653 6.03478 14.4456C5.8845 14.197 5.64052 14.0013 5.15256 13.6099L4.33897 12.9572C2.65086 11.6031 1.80681 10.926 1.7012 10.3097C1.60971 9.77576 1.78495 9.23059 2.16945 8.85298C2.61327 8.4171 3.68983 8.37084 5.84294 8.27831L6.88065 8.23372C7.50302 8.20698 7.81421 8.1936 8.08036 8.08176C8.31557 7.98292 8.52446 7.82951 8.69014 7.63393C8.87761 7.41263 8.98635 7.1176 9.20384 6.52753L9.56646 5.5437Z"
                    fill="#FFC400"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconPopoverArrowBL = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 0H0V12C0 5.37258 5.37258 0 12 0Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconGift = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.4997 2.08301C14.3406 2.08301 15.833 3.57539 15.833 5.41634C15.833 6.02387 15.6704 6.59343 15.3865 7.08393L19.1664 7.08301V8.74965H17.4997V17.083C17.4997 17.5432 17.1266 17.9163 16.6664 17.9163H3.33301C2.87277 17.9163 2.49967 17.5432 2.49967 17.083V8.74965H0.833008V7.08301L4.61282 7.08393C4.32887 6.59343 4.16634 6.02387 4.16634 5.41634C4.16634 3.57539 5.65872 2.08301 7.49968 2.08301C8.49569 2.08301 9.38969 2.51985 10.0004 3.21239C10.6097 2.51985 11.5037 2.08301 12.4997 2.08301ZM9.16636 8.74965H4.16634V16.2497H9.16636V8.74965ZM15.833 8.74965H10.833V16.2497H15.833V8.74965ZM7.49968 3.74967C6.5792 3.74967 5.83301 4.49587 5.83301 5.41634C5.83301 6.29497 6.51291 7.01481 7.37529 7.07843L7.49968 7.08301H9.16636V5.41634C9.16636 4.58164 8.55278 3.89025 7.75199 3.76865L7.62407 3.75425L7.49968 3.74967ZM12.4997 3.74967C11.621 3.74967 10.9012 4.42957 10.8376 5.29196L10.833 5.41634V7.08301H12.4997C13.3783 7.08301 14.0981 6.40311 14.1618 5.54072L14.1664 5.41634C14.1664 4.49587 13.4202 3.74967 12.4997 3.74967Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconProfit = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="1em"
                height="1em"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.50423 2.50195H17.5042C17.9645 2.50195 18.3376 2.87504 18.3376 3.33529V16.6686C18.3376 17.1288 17.9645 17.5019 17.5042 17.5019H2.50423C2.044 17.5019 1.6709 17.1288 1.6709 16.6686V3.33529C1.6709 2.87504 2.044 2.50195 2.50423 2.50195ZM3.33757 4.16862V15.8352H16.6709V4.16862H3.33757ZM7.08757 11.6686H11.6709C11.901 11.6686 12.0876 11.4821 12.0876 11.2519C12.0876 11.0218 11.901 10.8352 11.6709 10.8352H8.33758C7.18697 10.8352 6.25423 9.90258 6.25423 8.75191C6.25423 7.60135 7.18697 6.66862 8.33758 6.66862H9.17092V5.00195H10.8376V6.66862H12.9209V8.33525H8.33758C8.10745 8.33525 7.9209 8.52183 7.9209 8.75191C7.9209 8.98208 8.10745 9.16858 8.33758 9.16858H11.6709C12.8215 9.16858 13.7542 10.1013 13.7542 11.2519C13.7542 12.4026 12.8215 13.3352 11.6709 13.3352H10.8376V15.0019H9.17092V13.3352H7.08757V11.6686Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);

export const IconHistory = (props: any) => (
    <Icon
        component={() => (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.6665 10.0003C1.6665 14.6003 5.39984 18.3337 9.99984 18.3337C14.5998 18.3337 18.3332 14.6003 18.3332 10.0003C18.3332 5.40033 14.5998 1.66699 9.99984 1.66699C5.39984 1.66699 1.6665 5.40033 1.6665 10.0003ZM14.7165 14.717C13.4665 15.967 11.7665 16.667 9.99984 16.667C8.23317 16.667 6.53317 15.967 5.28317 14.717C4.03317 13.467 3.33317 11.767 3.33317 10.0003C3.33317 8.23366 4.03317 6.53366 5.28317 5.28366C6.53317 4.03366 8.23317 3.33366 9.99984 3.33366C11.7665 3.33366 13.4665 4.03366 14.7165 5.28366C15.9665 6.53366 16.6665 8.23366 16.6665 10.0003C16.6665 11.767 15.9665 13.467 14.7165 14.717ZM10.833 9.65052V6.66719L10.8413 6.65885C10.8413 6.20052 10.4663 5.82552 10.008 5.82552C9.54964 5.82552 9.17464 6.20052 9.17464 6.65885V9.99219C9.17464 10.2172 9.25798 10.4255 9.41631 10.5839L11.7746 12.9422C12.0996 13.2672 12.6246 13.2672 12.9496 12.9422C13.2746 12.6172 13.2746 12.0922 12.9496 11.7672L10.833 9.65052Z"
                    fill="currentColor"
                />
            </svg>
        )}
        {...props}
    />
);
